webpackJsonp([26],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_first_router_link__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_first_router_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_first_router_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Link = function (_Component) {
  _inherits(Link, _Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.root, this.props.className);
    }
  }, {
    key: 'getElement',
    value: function getElement() {
      var href = this.props.href;


      if (typeof href === 'string' && href.includes('://')) {
        return 'a';
      }

      // temporary return as there's no `store` within storybook
      return __WEBPACK_IMPORTED_MODULE_3_redux_first_router_link___default.a;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          label = _props.label,
          href = _props.href,
          restProps = _objectWithoutProperties(_props, ['children', 'label', 'href']);

      var Element = this.getElement();

      if (href) {
        restProps[Element === 'a' ? 'href' : 'to'] = href;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Element,
        _extends({}, restProps, { className: this.getClassName() }),
        children || label
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Link.defaultProps = {
  className: '',
  children: null,
  label: '',
  href: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__status__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Client__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__endpoints_Auth__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__endpoints_Activity__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__endpoints_Child__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__endpoints_Employee__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__endpoints_Invitation__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__endpoints_Klarna__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__endpoints_Parent__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__endpoints_Profile__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__endpoints_School__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__endpoints_Search__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__endpoints_Signup__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__endpoints_User__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__endpoints_Topic__ = __webpack_require__(1153);



















var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var client = new __WEBPACK_IMPORTED_MODULE_2__Client__["a" /* default */](isBrowser() ? __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].API_ENDPOINT : __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].API_OVERRIDE, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].OAUTH2_CLIENT_ID);

var auth = new __WEBPACK_IMPORTED_MODULE_3__endpoints_Auth__["a" /* default */](client);
var activity = new __WEBPACK_IMPORTED_MODULE_4__endpoints_Activity__["a" /* default */](client);
var child = new __WEBPACK_IMPORTED_MODULE_5__endpoints_Child__["a" /* default */](client);
var employee = new __WEBPACK_IMPORTED_MODULE_6__endpoints_Employee__["a" /* default */](client);
var invitation = new __WEBPACK_IMPORTED_MODULE_7__endpoints_Invitation__["a" /* default */](client);
var klarna = new __WEBPACK_IMPORTED_MODULE_8__endpoints_Klarna__["a" /* default */](client);
var parent = new __WEBPACK_IMPORTED_MODULE_9__endpoints_Parent__["a" /* default */](client);
var profile = new __WEBPACK_IMPORTED_MODULE_10__endpoints_Profile__["a" /* default */](client);
var school = new __WEBPACK_IMPORTED_MODULE_11__endpoints_School__["a" /* default */](client);
var topic = new __WEBPACK_IMPORTED_MODULE_15__endpoints_Topic__["a" /* default */](client);
var search = new __WEBPACK_IMPORTED_MODULE_12__endpoints_Search__["a" /* default */](client);
var signup = new __WEBPACK_IMPORTED_MODULE_13__endpoints_Signup__["a" /* default */](client);
var user = new __WEBPACK_IMPORTED_MODULE_14__endpoints_User__["a" /* default */](client);

/* harmony default export */ __webpack_exports__["a"] = ({
  client: client,
  status: __WEBPACK_IMPORTED_MODULE_1__status__["a" /* default */],

  auth: auth,
  activity: activity,
  child: child,
  employee: employee,
  invitation: invitation,
  klarna: klarna,
  parent: parent,
  profile: profile,
  search: search,
  school: school,
  topic: topic,
  signup: signup,
  user: user
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'findActivity';

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARENT_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPLOYEE_TAB; });
var NAME = 'profile';
var PARENT_TAB = 'profileParent';
var EMPLOYEE_TAB = 'profileEmployee';

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'login';

/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Client__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(109);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var TOKEN_NAME = 'token';

var Persister = function () {
  function Persister() {
    _classCallCheck(this, Persister);

    this.cookie = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();
  }

  _createClass(Persister, [{
    key: 'save',
    value: function save(key, value) {
      var maxAge = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(2, 'weeks');
      this.cookie.set(key, value, {
        path: '/',
        expires: __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(maxAge).toDate(),
        maxAge: maxAge.asSeconds(),
        secure: "production" !== 'development'
      });
    }
  }, {
    key: 'load',
    value: function load(key) {
      return this.cookie.get(key) || null;
    }
  }, {
    key: 'remove',
    value: function remove(key) {
      this.cookie.remove(key);
    }
  }, {
    key: 'isSupported',
    value: function isSupported() {
      return true;
    }
  }]);

  return Persister;
}();

function parseCredentials(credentials) {
  return {
    accessToken: credentials.access_token,
    expiresIn: credentials.expires_in,
    tokenType: credentials.token_type,
    scope: credentials.scope,
    refreshToken: credentials.refresh_token
  };
}

var Token = function () {
  function Token(client) {
    _classCallCheck(this, Token);

    this.client = client;
    this.persister = new Persister();
    this.load();
  }

  _createClass(Token, [{
    key: 'save',
    value: function save() {
      this.persister.save(TOKEN_NAME, this.credentials);
    }
  }, {
    key: 'load',
    value: function load() {
      this.credentials = this.persister.load(TOKEN_NAME);
    }
  }, {
    key: 'get',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(username, password) {
        var response, credentials;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].auth.getToken(username, password);

              case 2:
                response = _context.sent;

                if (!(response.errors != null)) {
                  _context.next = 7;
                  break;
                }

                throw new Error("Couldn't refresh the token.");

              case 7:
                credentials = parseCredentials(response.data);

                this.credentials = credentials;
                this.save();
                return _context.abrupt('return', credentials);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'getFromAuthResponse',
    value: function getFromAuthResponse(authResponse) {
      var credentials = parseCredentials(authResponse);
      this.credentials = credentials;
      this.save();
      return credentials;
    }
  }, {
    key: 'refreshToken',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, credentials;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.credentials == null)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Not authenicated.');

              case 2:
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].auth.refreshToken();

              case 4:
                response = _context2.sent;

                if (!response.errors) {
                  _context2.next = 9;
                  break;
                }

                throw new Error("Couldn't refresh the token.");

              case 9:
                credentials = parseCredentials(response.data);

                this.credentials = credentials;
                this.save();
                return _context2.abrupt('return', credentials);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshToken() {
        return _ref2.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: 'headers',
    value: function headers() {
      if (this.credentials != null) {
        var _credentials = this.credentials,
            tokenType = _credentials.tokenType,
            accessToken = _credentials.accessToken;

        return {
          Authorization: tokenType + ' ' + accessToken
        };
      }
      return {};
    }
  }, {
    key: 'revoke',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var accessToken;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                accessToken = this.credentials.accessToken;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].auth.revokeToken(accessToken);

              case 3:
                this.clear();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function revoke() {
        return _ref3.apply(this, arguments);
      }

      return revoke;
    }()
  }, {
    key: 'clear',
    value: function clear() {
      this.credentials = null;
      this.persister.remove(TOKEN_NAME);
    }
  }]);

  return Token;
}();

/* harmony default export */ __webpack_exports__["a"] = (Token);

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 381,
	"./af.js": 381,
	"./ar": 382,
	"./ar-dz": 383,
	"./ar-dz.js": 383,
	"./ar-kw": 384,
	"./ar-kw.js": 384,
	"./ar-ly": 385,
	"./ar-ly.js": 385,
	"./ar-ma": 386,
	"./ar-ma.js": 386,
	"./ar-sa": 387,
	"./ar-sa.js": 387,
	"./ar-tn": 388,
	"./ar-tn.js": 388,
	"./ar.js": 382,
	"./az": 389,
	"./az.js": 389,
	"./be": 390,
	"./be.js": 390,
	"./bg": 391,
	"./bg.js": 391,
	"./bm": 392,
	"./bm.js": 392,
	"./bn": 393,
	"./bn.js": 393,
	"./bo": 394,
	"./bo.js": 394,
	"./br": 395,
	"./br.js": 395,
	"./bs": 396,
	"./bs.js": 396,
	"./ca": 397,
	"./ca.js": 397,
	"./cs": 398,
	"./cs.js": 398,
	"./cv": 399,
	"./cv.js": 399,
	"./cy": 400,
	"./cy.js": 400,
	"./da": 401,
	"./da.js": 401,
	"./de": 402,
	"./de-at": 403,
	"./de-at.js": 403,
	"./de-ch": 404,
	"./de-ch.js": 404,
	"./de.js": 402,
	"./dv": 405,
	"./dv.js": 405,
	"./el": 406,
	"./el.js": 406,
	"./en-au": 407,
	"./en-au.js": 407,
	"./en-ca": 408,
	"./en-ca.js": 408,
	"./en-gb": 409,
	"./en-gb.js": 409,
	"./en-ie": 410,
	"./en-ie.js": 410,
	"./en-nz": 411,
	"./en-nz.js": 411,
	"./eo": 412,
	"./eo.js": 412,
	"./es": 413,
	"./es-do": 414,
	"./es-do.js": 414,
	"./es-us": 415,
	"./es-us.js": 415,
	"./es.js": 413,
	"./et": 416,
	"./et.js": 416,
	"./eu": 417,
	"./eu.js": 417,
	"./fa": 418,
	"./fa.js": 418,
	"./fi": 419,
	"./fi.js": 419,
	"./fo": 420,
	"./fo.js": 420,
	"./fr": 421,
	"./fr-ca": 422,
	"./fr-ca.js": 422,
	"./fr-ch": 423,
	"./fr-ch.js": 423,
	"./fr.js": 421,
	"./fy": 424,
	"./fy.js": 424,
	"./gd": 425,
	"./gd.js": 425,
	"./gl": 426,
	"./gl.js": 426,
	"./gom-latn": 427,
	"./gom-latn.js": 427,
	"./gu": 428,
	"./gu.js": 428,
	"./he": 429,
	"./he.js": 429,
	"./hi": 430,
	"./hi.js": 430,
	"./hr": 431,
	"./hr.js": 431,
	"./hu": 432,
	"./hu.js": 432,
	"./hy-am": 433,
	"./hy-am.js": 433,
	"./id": 434,
	"./id.js": 434,
	"./is": 435,
	"./is.js": 435,
	"./it": 436,
	"./it.js": 436,
	"./ja": 437,
	"./ja.js": 437,
	"./jv": 438,
	"./jv.js": 438,
	"./ka": 439,
	"./ka.js": 439,
	"./kk": 440,
	"./kk.js": 440,
	"./km": 441,
	"./km.js": 441,
	"./kn": 442,
	"./kn.js": 442,
	"./ko": 443,
	"./ko.js": 443,
	"./ky": 444,
	"./ky.js": 444,
	"./lb": 445,
	"./lb.js": 445,
	"./lo": 446,
	"./lo.js": 446,
	"./lt": 447,
	"./lt.js": 447,
	"./lv": 448,
	"./lv.js": 448,
	"./me": 449,
	"./me.js": 449,
	"./mi": 450,
	"./mi.js": 450,
	"./mk": 451,
	"./mk.js": 451,
	"./ml": 452,
	"./ml.js": 452,
	"./mr": 453,
	"./mr.js": 453,
	"./ms": 454,
	"./ms-my": 455,
	"./ms-my.js": 455,
	"./ms.js": 454,
	"./mt": 456,
	"./mt.js": 456,
	"./my": 457,
	"./my.js": 457,
	"./nb": 458,
	"./nb.js": 458,
	"./ne": 459,
	"./ne.js": 459,
	"./nl": 460,
	"./nl-be": 461,
	"./nl-be.js": 461,
	"./nl.js": 460,
	"./nn": 462,
	"./nn.js": 462,
	"./pa-in": 463,
	"./pa-in.js": 463,
	"./pl": 464,
	"./pl.js": 464,
	"./pt": 465,
	"./pt-br": 466,
	"./pt-br.js": 466,
	"./pt.js": 465,
	"./ro": 467,
	"./ro.js": 467,
	"./ru": 468,
	"./ru.js": 468,
	"./sd": 469,
	"./sd.js": 469,
	"./se": 470,
	"./se.js": 470,
	"./si": 471,
	"./si.js": 471,
	"./sk": 472,
	"./sk.js": 472,
	"./sl": 473,
	"./sl.js": 473,
	"./sq": 474,
	"./sq.js": 474,
	"./sr": 475,
	"./sr-cyrl": 476,
	"./sr-cyrl.js": 476,
	"./sr.js": 475,
	"./ss": 477,
	"./ss.js": 477,
	"./sv": 478,
	"./sv.js": 478,
	"./sw": 479,
	"./sw.js": 479,
	"./ta": 480,
	"./ta.js": 480,
	"./te": 481,
	"./te.js": 481,
	"./tet": 482,
	"./tet.js": 482,
	"./th": 483,
	"./th.js": 483,
	"./tl-ph": 484,
	"./tl-ph.js": 484,
	"./tlh": 485,
	"./tlh.js": 485,
	"./tr": 486,
	"./tr.js": 486,
	"./tzl": 487,
	"./tzl.js": 487,
	"./tzm": 488,
	"./tzm-latn": 489,
	"./tzm-latn.js": 489,
	"./tzm.js": 488,
	"./uk": 490,
	"./uk.js": 490,
	"./ur": 491,
	"./ur.js": 491,
	"./uz": 492,
	"./uz-latn": 493,
	"./uz-latn.js": 493,
	"./uz.js": 492,
	"./vi": 494,
	"./vi.js": 494,
	"./x-pseudo": 495,
	"./x-pseudo.js": 495,
	"./yo": 496,
	"./yo.js": 496,
	"./zh-cn": 497,
	"./zh-cn.js": 497,
	"./zh-hk": 498,
	"./zh-hk.js": 498,
	"./zh-tw": 499,
	"./zh-tw.js": 499
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1140;

/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Auth = function (_Endpoint) {
  _inherits(Auth, _Endpoint);

  function Auth() {
    _classCallCheck(this, Auth);

    return _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).apply(this, arguments));
  }

  _createClass(Auth, [{
    key: 'getToken',
    value: function getToken(username, password) {
      return this.client.request({
        method: 'POST',
        endpoint: '/oauth2/token/',
        data: {
          client_id: this.client.clientId,
          grant_type: 'password',
          username: username,
          password: password
        }
      }, false);
    }
  }, {
    key: 'refreshToken',
    value: function refreshToken() {
      var refreshToken = this.client.getRefreshToken();
      if (refreshToken == null) {
        return Promise.reject(new Error('No valid refresh token found.'));
      }
      return this.client.request({
        method: 'POST',
        endpoint: '/oauth2/token/',
        data: {
          client_id: this.client.clientId,
          grant_type: 'refresh_token',
          refresh_token: refreshToken
        }
      }, false);
    }
  }, {
    key: 'revokeToken',
    value: function revokeToken(accessToken) {
      return this.client.request({
        method: 'POST',
        endpoint: '/oauth2/revoke_token/',
        data: {
          client_id: this.client.clientId,
          token: accessToken
        }
      });
    }
  }]);

  return Auth;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Participant = function (_Endpoint) {
  _inherits(Participant, _Endpoint);

  function Participant(client, activityId) {
    _classCallCheck(this, Participant);

    var _this = _possibleConstructorReturn(this, (Participant.__proto__ || Object.getPrototypeOf(Participant)).call(this, client));

    _this.activityId = activityId;
    return _this;
  }

  _createClass(Participant, [{
    key: 'list',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities/' + this.activityId + '/participants'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function list() {
        return _ref.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'add',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(childId) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + this.activityId + '/participants',
                  data: { child_id: childId }
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function add(_x) {
        return _ref2.apply(this, arguments);
      }

      return add;
    }()
  }, {
    key: 'remove',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(childId) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'DELETE',
                  endpoint: '/activities/' + this.activityId + '/participants/' + childId
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function remove(_x2) {
        return _ref3.apply(this, arguments);
      }

      return remove;
    }()
  }]);

  return Participant;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

var Membership = function (_Endpoint2) {
  _inherits(Membership, _Endpoint2);

  function Membership(client, activityId) {
    _classCallCheck(this, Membership);

    var _this2 = _possibleConstructorReturn(this, (Membership.__proto__ || Object.getPrototypeOf(Membership)).call(this, client));

    _this2.activityId = activityId;
    return _this2;
  }

  _createClass(Membership, [{
    key: 'list',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities/' + this.activityId + '/memberships'
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function list() {
        return _ref4.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'remove',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.client.request({
                  method: 'DELETE',
                  endpoint: '/activities/' + this.activityId + '/memberships/' + id
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function remove(_x3) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }()
  }]);

  return Membership;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

var Message = function (_Endpoint3) {
  _inherits(Message, _Endpoint3);

  function Message(client, activityId) {
    _classCallCheck(this, Message);

    var _this3 = _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).call(this, client));

    _this3.activityId = activityId;
    return _this3;
  }

  _createClass(Message, [{
    key: 'post',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(body) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + this.activityId + '/messages',
                  data: { body: body }
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function post(_x4) {
        return _ref6.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities/' + this.activityId + '/messages'
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function list() {
        return _ref7.apply(this, arguments);
      }

      return list;
    }()
  }]);

  return Message;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

var Invitation = function (_Endpoint4) {
  _inherits(Invitation, _Endpoint4);

  function Invitation(client, activityId) {
    _classCallCheck(this, Invitation);

    var _this4 = _possibleConstructorReturn(this, (Invitation.__proto__ || Object.getPrototypeOf(Invitation)).call(this, client));

    _this4.activityId = activityId;
    return _this4;
  }

  _createClass(Invitation, [{
    key: 'invite',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(email, message) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + this.activityId + '/invitations',
                  data: { email: email, message: message }
                }));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function invite(_x5, _x6) {
        return _ref8.apply(this, arguments);
      }

      return invite;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities/' + this.activityId + '/invitations'
                }));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function list() {
        return _ref9.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', this.client.request({
                  method: 'DELETE',
                  endpoint: '/activities/' + this.activityId + '/invitations/' + id
                }));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _delete(_x7) {
        return _ref10.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'resend',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + this.activityId + '/invitations/' + id + '/resend'
                }));

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function resend(_x8) {
        return _ref11.apply(this, arguments);
      }

      return resend;
    }()
  }]);

  return Invitation;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

var Activity = function (_Endpoint5) {
  _inherits(Activity, _Endpoint5);

  function Activity() {
    _classCallCheck(this, Activity);

    return _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).apply(this, arguments));
  }

  _createClass(Activity, [{
    key: 'create',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(params) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities',
                  data: params
                }));

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function create(_x9) {
        return _ref12.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id, params) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt('return', this.client.request({
                  method: 'PATCH',
                  endpoint: '/activities/' + id,
                  data: params
                }));

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function update(_x10, _x11) {
        return _ref13.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'calculatePrice',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(params) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/calculate_price',
                  data: params
                }));

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function calculatePrice(_x12) {
        return _ref14.apply(this, arguments);
      }

      return calculatePrice;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities'
                }));

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function list() {
        return _ref15.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'get',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(id) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities/' + id
                }));

              case 1:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function get(_x13) {
        return _ref16.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'pay',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(id) {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + id + '/pay'
                }));

              case 1:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function pay(_x14) {
        return _ref17.apply(this, arguments);
      }

      return pay;
    }()
  }, {
    key: 'getReceipt',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(id) {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/activities/' + id + '/receipt'
                }));

              case 1:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getReceipt(_x15) {
        return _ref18.apply(this, arguments);
      }

      return getReceipt;
    }()
  }, {
    key: 'join',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(id) {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + id + '/join'
                }));

              case 1:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function join(_x16) {
        return _ref19.apply(this, arguments);
      }

      return join;
    }()
  }, {
    key: 'start',
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(id) {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/activities/' + id + '/start'
                }));

              case 1:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function start(_x17) {
        return _ref20.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: 'messages',
    value: function messages(id) {
      return new Message(this.client, id);
    }
  }, {
    key: 'participants',
    value: function participants(id) {
      return new Participant(this.client, id);
    }
  }, {
    key: 'invitations',
    value: function invitations(id) {
      return new Invitation(this.client, id);
    }
  }, {
    key: 'memberships',
    value: function memberships(id) {
      return new Membership(this.client, id);
    }
  }]);

  return Activity;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Activity);

/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Child = function (_Endpoint) {
  _inherits(Child, _Endpoint);

  function Child() {
    _classCallCheck(this, Child);

    return _possibleConstructorReturn(this, (Child.__proto__ || Object.getPrototypeOf(Child)).apply(this, arguments));
  }

  _createClass(Child, [{
    key: 'list',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/children'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function list() {
        return _ref.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'create',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/children',
                  data: params
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x) {
        return _ref2.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, params) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'PATCH',
                  endpoint: '/children/' + id,
                  data: params
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return Child;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Child);

/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Employee = function (_Endpoint) {
  _inherits(Employee, _Endpoint);

  function Employee() {
    _classCallCheck(this, Employee);

    return _possibleConstructorReturn(this, (Employee.__proto__ || Object.getPrototypeOf(Employee)).apply(this, arguments));
  }

  _createClass(Employee, [{
    key: 'getCurrent',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/employees/current'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCurrent() {
        return _ref.apply(this, arguments);
      }

      return getCurrent;
    }()
  }, {
    key: 'get',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(employeeId) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/employees/' + employeeId
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x) {
        return _ref2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'create',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/employees',
                  data: params
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function create(_x2) {
        return _ref3.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.client.request({
                  method: 'PATCH',
                  endpoint: '/employees/current',
                  data: params
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function update(_x3) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'upload',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(params) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.client.request({
                  method: 'PATCH',
                  endpoint: '/employees/current/upload',
                  data: params
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function upload(_x4) {
        return _ref5.apply(this, arguments);
      }

      return upload;
    }()
  }]);

  return Employee;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Employee);

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Invitation = function (_Endpoint) {
  _inherits(Invitation, _Endpoint);

  function Invitation() {
    _classCallCheck(this, Invitation);

    return _possibleConstructorReturn(this, (Invitation.__proto__ || Object.getPrototypeOf(Invitation)).apply(this, arguments));
  }

  _createClass(Invitation, [{
    key: 'listPending',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/invitations'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function listPending() {
        return _ref.apply(this, arguments);
      }

      return listPending;
    }()
  }, {
    key: 'get',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/invitations/' + token
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x) {
        return _ref2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'accept',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(token) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/invitations/' + token + '/accept'
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function accept(_x2) {
        return _ref3.apply(this, arguments);
      }

      return accept;
    }()
  }, {
    key: 'reject',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(token) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/invitations/' + token + '/reject'
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function reject(_x3) {
        return _ref4.apply(this, arguments);
      }

      return reject;
    }()
  }]);

  return Invitation;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Invitation);

/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Klarna = function (_Endpoint) {
  _inherits(Klarna, _Endpoint);

  function Klarna() {
    _classCallCheck(this, Klarna);

    return _possibleConstructorReturn(this, (Klarna.__proto__ || Object.getPrototypeOf(Klarna)).apply(this, arguments));
  }

  _createClass(Klarna, [{
    key: 'push',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(orderId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/klarna/' + orderId + '/push'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function push(_x) {
        return _ref.apply(this, arguments);
      }

      return push;
    }()
  }]);

  return Klarna;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Klarna);

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Parent = function (_Endpoint) {
  _inherits(Parent, _Endpoint);

  function Parent() {
    _classCallCheck(this, Parent);

    return _possibleConstructorReturn(this, (Parent.__proto__ || Object.getPrototypeOf(Parent)).apply(this, arguments));
  }

  _createClass(Parent, [{
    key: 'create',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/parents'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create() {
        return _ref.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'getCurrent',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/parents/current'
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCurrent() {
        return _ref2.apply(this, arguments);
      }

      return getCurrent;
    }()
  }]);

  return Parent;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Parent);

/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Profile = function (_Endpoint) {
  _inherits(Profile, _Endpoint);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'getCurrent',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/profiles/current'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCurrent() {
        return _ref.apply(this, arguments);
      }

      return getCurrent;
    }()
  }, {
    key: 'create',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/profiles',
                  data: params
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x) {
        return _ref2.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'PATCH',
                  endpoint: '/profiles/current',
                  data: params
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x2) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return Profile;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var School = function (_Endpoint) {
  _inherits(School, _Endpoint);

  function School() {
    _classCallCheck(this, School);

    return _possibleConstructorReturn(this, (School.__proto__ || Object.getPrototypeOf(School)).apply(this, arguments));
  }

  _createClass(School, [{
    key: 'list',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/schools'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function list() {
        return _ref.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'get',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/schools/' + id
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x) {
        return _ref2.apply(this, arguments);
      }

      return get;
    }()
  }]);

  return School;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (School);

/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Profile = function (_Endpoint) {
  _inherits(Profile, _Endpoint);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'suggestEmployees',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(prefix) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/suggest_employees',
                  data: { prefix: prefix }
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function suggestEmployees(_x) {
        return _ref.apply(this, arguments);
      }

      return suggestEmployees;
    }()
  }, {
    key: 'suggestTopics',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prefix) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/suggest_topics',
                  data: { prefix: prefix }
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function suggestTopics(_x2) {
        return _ref2.apply(this, arguments);
      }

      return suggestTopics;
    }()
  }, {
    key: 'suggestSchools',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(prefix) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/suggest_schools',
                  data: { prefix: prefix }
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function suggestSchools(_x3) {
        return _ref3.apply(this, arguments);
      }

      return suggestSchools;
    }()
  }, {
    key: 'suggest',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(prefix) {
        var results;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (prefix) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return', []);

              case 2:
                _context4.next = 4;
                return Promise.all([this.suggestTopics(prefix), this.suggestSchools(prefix)]);

              case 4:
                results = _context4.sent;
                return _context4.abrupt('return', [].concat(_toConsumableArray(results[0].data.map(function (x) {
                  return _extends({}, x, { type: 'topic' });
                })), _toConsumableArray(results[1].data.map(function (x) {
                  return _extends({}, x, { type: 'school' });
                }))));

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function suggest(_x4) {
        return _ref4.apply(this, arguments);
      }

      return suggest;
    }()
  }, {
    key: 'findEmployees',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(params) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/employees',
                  data: params
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function findEmployees(_x5) {
        return _ref5.apply(this, arguments);
      }

      return findEmployees;
    }()
  }, {
    key: 'findActivities',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(params) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/activities',
                  data: params
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function findActivities(_x6) {
        return _ref6.apply(this, arguments);
      }

      return findActivities;
    }()
  }, {
    key: 'findSchools',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/schools',
                  data: params
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function findSchools(_x7) {
        return _ref7.apply(this, arguments);
      }

      return findSchools;
    }()
  }, {
    key: 'findTopics',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(params) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/search/topics',
                  data: params
                }));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function findTopics(_x8) {
        return _ref8.apply(this, arguments);
      }

      return findTopics;
    }()
  }]);

  return Profile;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Signup = function (_Endpoint) {
  _inherits(Signup, _Endpoint);

  function Signup() {
    _classCallCheck(this, Signup);

    return _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).apply(this, arguments));
  }

  _createClass(Signup, [{
    key: 'create',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/signup',
                  data: params
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _ref.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return Signup;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Signup);

/***/ }),

/***/ 1152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var User = function (_Endpoint) {
  _inherits(User, _Endpoint);

  function User() {
    _classCallCheck(this, User);

    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
  }

  _createClass(User, [{
    key: 'signup',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email, password, source) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/users',
                  data: {
                    email: email,
                    password: password,
                    source: source
                  }
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signup(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return signup;
    }()
  }, {
    key: 'activate',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/users/activate',
                  data: {
                    token: token,
                    clientId: this.client.clientId
                  }
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function activate(_x4) {
        return _ref2.apply(this, arguments);
      }

      return activate;
    }()
  }, {
    key: 'requestPasswordReset',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(email) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/users/request_password_reset',
                  data: {
                    email: email
                  }
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestPasswordReset(_x5) {
        return _ref3.apply(this, arguments);
      }

      return requestPasswordReset;
    }()
  }, {
    key: 'passwordReset',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(userId, token, password) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.client.request({
                  method: 'POST',
                  endpoint: '/users/' + userId + '/password_reset',
                  data: {
                    token: token,
                    password: password
                  }
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function passwordReset(_x6, _x7, _x8) {
        return _ref4.apply(this, arguments);
      }

      return passwordReset;
    }()
  }, {
    key: 'getCurrent',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/users/current'
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCurrent() {
        return _ref5.apply(this, arguments);
      }

      return getCurrent;
    }()
  }]);

  return User;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endpoint__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Topic = function (_Endpoint) {
  _inherits(Topic, _Endpoint);

  function Topic() {
    _classCallCheck(this, Topic);

    return _possibleConstructorReturn(this, (Topic.__proto__ || Object.getPrototypeOf(Topic)).apply(this, arguments));
  }

  _createClass(Topic, [{
    key: 'list',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.client.request({
                  method: 'GET',
                  endpoint: '/topics'
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function list() {
        return _ref.apply(this, arguments);
      }

      return list;
    }()
  }]);

  return Topic;
}(__WEBPACK_IMPORTED_MODULE_0__Endpoint__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Topic);

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3tuPE","center":"_1qiRP","svg":"SGSri","rotate":"_16oHj","dash":"_2AGYD"};

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return locationSelector; });
/* harmony export (immutable) */ __webpack_exports__["c"] = ensureAuthenticated;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTE_LOGOUT; });
/* unused harmony export staticPages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_djedi_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_first_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_first_router_restore_scroll__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_first_router_restore_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_first_router_restore_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_api__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_App_actions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_Home_constants__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_ViewActivity_constants__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_FindActivity_constants__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_Invitation_constants__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_Login_constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_Receipt_constants__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_SignupVerify_constants__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_ActivitiesAndSchools_constants__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_CreateActivity_constants__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_Profile_constants__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_Signup_constants__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_PasswordReset_constants__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_Universal__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_state_persist__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reducers__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sagas__ = __webpack_require__(236);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ref2,
    _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(ensureAuthenticated);
































var DEFAULT_PAGE_TYPE = 'view';

var locationSelector = function locationSelector(state) {
  return state.get('location');
};

function ensureAuthenticated(message) {
  var _ref, next, query;

  return regeneratorRuntime.wrap(function ensureAuthenticated$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["f" /* select */])(locationSelector);

        case 2:
          _ref = _context.sent;
          next = _ref.pathname;
          _context.prev = 4;
          _context.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_9_api__["a" /* default */].user, 'getCurrent']);

        case 7:
          _context.next = 15;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context['catch'](4);
          query = { message: message, next: next };

          Object(__WEBPACK_IMPORTED_MODULE_24_state_persist__["c" /* save */])('next', next);
          _context.next = 15;
          return Object(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["d" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_redux_first_router__["redirect"])(Object(__WEBPACK_IMPORTED_MODULE_25_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_15_views_Login_constants__["a" /* NAME */], { query: query })));

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 9]]);
}

var ROUTE_LOGOUT = 'logout';
var staticPages = {
  'fragor-och-svar': 'FAQ',
  kontakt: 'Contact',
  'om-oss': 'AboutUs',
  'sa-funkar-det': 'HowItWorks',
  'allmanna-villkor': 'UserTerms',
  'villkor-for-ansokan': 'ApplicationTerms'
};

var routes = new __WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]((_ref2 = {}, _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_11_views_Home_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_11_views_Home_constants__["a" /* NAME */],
  path: '/',
  component: 'Home'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_13_views_FindActivity_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_13_views_FindActivity_constants__["a" /* NAME */],
  path: '/hitta',
  component: 'FindActivity',
  fullWidth: true,
  footerless: true,
  saga: __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport___default()({
    id: 'views/FindActivity/sagas',
    file: '/app/source/state/routes.js',
    load: function load() {
      return Promise.all([__webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 537)), __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss___default()('views/FindActivity/sagas', {})]).then(function (proms) {
        return proms[0];
      });
    },
    path: function path() {
      return __WEBPACK_IMPORTED_MODULE_0_path___default.a.join(__dirname, 'views/FindActivity/sagas');
    },
    resolve: function resolve() {
      return /*require.resolve*/(537);
    },
    chunkName: function chunkName() {
      return 'views/FindActivity/sagas';
    }
  }),
  reducer: __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport___default()({
    id: 'views/FindActivity/reducer',
    file: '/app/source/state/routes.js',
    load: function load() {
      return Promise.all([__webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 533)), __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss___default()('views/FindActivity/reducer', {})]).then(function (proms) {
        return proms[0];
      });
    },
    path: function path() {
      return __WEBPACK_IMPORTED_MODULE_0_path___default.a.join(__dirname, 'views/FindActivity/reducer');
    },
    resolve: function resolve() {
      return /*require.resolve*/(533);
    },
    chunkName: function chunkName() {
      return 'views/FindActivity/reducer';
    }
  })
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_19_views_CreateActivity_constants__["b" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_19_views_CreateActivity_constants__["b" /* NAME */],
  path: '/aktiviteter/skapa',
  component: 'CreateActivity'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_19_views_CreateActivity_constants__["a" /* EDIT_NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_19_views_CreateActivity_constants__["a" /* EDIT_NAME */],
  path: '/aktiviteter/:activityId/andra',
  component: 'CreateActivity',
  authRequired: true
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_16_views_Receipt_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_16_views_Receipt_constants__["a" /* NAME */],
  path: '/aktiviteter/:activityId/kvitto',
  component: 'Receipt'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_12_views_ViewActivity_constants__["b" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_12_views_ViewActivity_constants__["b" /* NAME */],
  path: '/aktiviteter/:activityId',
  component: 'ViewActivity',
  authRequired: true
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_21_views_Signup_constants__["c" /* PARENT_SIGNUP */], {
  id: __WEBPACK_IMPORTED_MODULE_21_views_Signup_constants__["c" /* PARENT_SIGNUP */],
  path: '/bli-medlem',
  component: 'Signup'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_21_views_Signup_constants__["a" /* LEADER_SIGNUP */], {
  id: __WEBPACK_IMPORTED_MODULE_21_views_Signup_constants__["a" /* LEADER_SIGNUP */],
  path: '/bli-ledare',
  component: 'Signup'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_17_views_SignupVerify_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_17_views_SignupVerify_constants__["a" /* NAME */],
  path: '/registrering/verifera/:token',
  component: 'SignupVerify'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_15_views_Login_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_15_views_Login_constants__["a" /* NAME */],
  path: '/logga-in',
  component: 'Login'
}), _defineProperty(_ref2, ROUTE_LOGOUT, {
  id: ROUTE_LOGOUT,
  path: '/logga-ut',
  component: 'Logout'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_20_views_Profile_constants__["b" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_20_views_Profile_constants__["b" /* NAME */],
  path: '/profil',
  component: 'Profile',
  authRequired: true
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_14_views_Invitation_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_14_views_Invitation_constants__["a" /* NAME */],
  path: '/inbjudan/:token',
  component: 'Invitation'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_22_views_PasswordReset_constants__["b" /* PASSWORD_RESET_REQUEST */], {
  id: __WEBPACK_IMPORTED_MODULE_22_views_PasswordReset_constants__["b" /* PASSWORD_RESET_REQUEST */],
  path: '/nytt-losenord',
  component: 'PasswordReset'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_22_views_PasswordReset_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_22_views_PasswordReset_constants__["a" /* NAME */],
  path: '/nytt-losenord/:userId/:token',
  component: 'PasswordReset'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_18_views_ActivitiesAndSchools_constants__["a" /* NAME */], {
  id: __WEBPACK_IMPORTED_MODULE_18_views_ActivitiesAndSchools_constants__["a" /* NAME */],
  path: '/aktiviteter-och-skolor',
  component: 'ActivitiesAndSchools'
}), _defineProperty(_ref2, __WEBPACK_IMPORTED_MODULE_5_redux_first_router__["NOT_FOUND"], {
  id: __WEBPACK_IMPORTED_MODULE_5_redux_first_router__["NOT_FOUND"],
  path: '/not-found',
  component: 'NotFound'
}), _ref2)).merge(new __WEBPACK_IMPORTED_MODULE_4_immutable__["Map"](Object.entries(staticPages).reduce(function (a, _ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      k = _ref4[0],
      v = _ref4[1];

  var b = _extends({}, a);
  b['static/' + k] = {
    id: 'static/' + k,
    path: '/' + k,
    component: v,
    pageType: 'static'
  };
  return b;
}, {}))).map(function (route) {
  return {
    id: route.id,
    path: route.path,
    component: route.component,
    isLoading: route.isLoading,
    getError: route.getError,
    fullWidth: route.fullWidth,
    pageType: route.pageType || DEFAULT_PAGE_TYPE,
    footerless: route.footerless || false,
    thunk: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
        var _ref6, _ref7, reducer, saga;

        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_23_components_Universal__["a" /* default */].preload({
                  component: route.component,
                  pageType: route.pageType || DEFAULT_PAGE_TYPE
                });

              case 2:
                _context2.next = 4;
                return Promise.all([__WEBPACK_IMPORTED_MODULE_3_djedi_react__["djedi"].prefetch(), route.reducer || Promise.resolve(), route.saga || Promise.resolve()]);

              case 4:
                _ref6 = _context2.sent;
                _ref7 = _slicedToArray(_ref6, 3);
                reducer = _ref7[1];
                saga = _ref7[2];


                dispatch(__WEBPACK_IMPORTED_MODULE_10_views_App_actions__["a" /* default */].addDjediNodes(__WEBPACK_IMPORTED_MODULE_3_djedi_react__["djedi"].track()));

                if (reducer) Object(__WEBPACK_IMPORTED_MODULE_26__reducers__["a" /* addReducer */])(route.id, reducer.default);

                if (!route.authRequired) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_27__sagas__["c" /* runSaga */])(ensureAuthenticated);

              case 13:
                if (!(saga && saga.initialize)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_27__sagas__["c" /* runSaga */])(saga.initialize);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, _this);
      }));

      return function thunk(_x) {
        return _ref5.apply(this, arguments);
      };
    }()
  };
}).toJS();

/* harmony default export */ __webpack_exports__["b"] = (function (history) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux_first_router__["connectRoutes"])(routes, {
    location: locationSelector,
    createHistory: function createHistory() {
      return history;
    },
    querySerializer: __WEBPACK_IMPORTED_MODULE_7_query_string___default.a,
    restoreScroll: __WEBPACK_IMPORTED_MODULE_6_redux_first_router_restore_scroll___default()(),
    onAfterChange: function onAfterChange(dispatch, getState) {
      if (typeof window !== 'undefined' && window.dataLayer) {
        var state = getState();

        var _locationSelector = locationSelector(state),
            pathname = _locationSelector.pathname;

        window.dataLayer.push({ event: 'pageview', pageview: pathname });
      }
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/site-logo.8842f198.png";

/***/ }),

/***/ 1163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Wr0HL"};

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"errorPage":"_38gSM"};

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AboutUs": [
		158,
		0
	],
	"./AboutUs.css": [
		534,
		23
	],
	"./AboutUs.js": [
		158,
		0
	],
	"./ApplicationTerms": [
		159,
		5
	],
	"./ApplicationTerms.js": [
		159,
		5
	],
	"./Contact": [
		160,
		4
	],
	"./Contact.js": [
		160,
		4
	],
	"./FAQ": [
		161,
		3
	],
	"./FAQ.js": [
		161,
		3
	],
	"./HowItWorks": [
		162,
		2
	],
	"./HowItWorks.js": [
		162,
		2
	],
	"./UserTerms": [
		163,
		1
	],
	"./UserTerms.css": [
		535,
		22
	],
	"./UserTerms.js": [
		163,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1165;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3KpwC","small":"Eh89_","medium":"_1szFn","large":"_16Bje"};

/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AboutUs": 158,
	"./AboutUs.css": 534,
	"./AboutUs.js": 158,
	"./ApplicationTerms": 159,
	"./ApplicationTerms.js": 159,
	"./Contact": 160,
	"./Contact.js": 160,
	"./FAQ": 161,
	"./FAQ.js": 161,
	"./HowItWorks": 162,
	"./HowItWorks.js": 162,
	"./UserTerms": 163,
	"./UserTerms.css": 535,
	"./UserTerms.js": 163
};
function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id])
		throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
	return __webpack_require__(id);
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1167;
module.exports = webpackContext;

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ActivitiesAndSchools/index": [
		553,
		17
	],
	"./App/index": [
		221
	],
	"./Chat/index": [
		536,
		14
	],
	"./CreateActivity/index": [
		554,
		7
	],
	"./FindActivity/index": [
		555,
		6
	],
	"./Home/index": [
		556,
		10
	],
	"./Invitation/index": [
		557,
		15
	],
	"./Login/index": [
		558,
		12
	],
	"./Logout/index": [
		559,
		20
	],
	"./NotFound/index": [
		560,
		19
	],
	"./PasswordReset/index": [
		561,
		13
	],
	"./Profile/index": [
		562,
		8
	],
	"./ProfileLeader/index": [
		563,
		24
	],
	"./Receipt/index": [
		564,
		16
	],
	"./Signup/index": [
		565,
		11
	],
	"./SignupVerify/index": [
		566,
		18
	],
	"./Switch/index": [
		222
	],
	"./ViewActivity/index": [
		567,
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1168;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1k23n"};

/***/ }),

/***/ 1177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_FacebookShare__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_layouts_Container__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_klarna_png__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_klarna_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_klarna_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_sting_png__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_sting_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_sting_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_verifiera_png__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_verifiera_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_verifiera_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Signup_constants__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var _ref = _jsx('div', {}, void 0, _jsx('div', {}, void 0, _jsx('strong', {}, void 0, 'friendtivity\u2122')), 'Org. 559117-6200 \u2013 Jungfrugatan 47, 114 44 Stockholm');

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.root, this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var account = this.props.account;


      return _jsx('footer', {
        className: this.getClassName()
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_layouts_Container__["a" /* default */], {
        size: 'large'
      }, void 0, _jsx('nav', {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.nav
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.navContainer
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["a" /* filterLinks */])(Footer.links, account).map(function (link) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_3_components_Link__["a" /* default */], {
          href: link.href
        }, link.href.type, link.label);
      }), _jsx(__WEBPACK_IMPORTED_MODULE_4_components_FacebookShare__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.facebookButton
      }))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.extra
      }, void 0, _ref, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.logos
      }, void 0, _jsx('a', {
        href: 'https://sting.co/sting-bolag/',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_7_assets_sting_png___default.a,
        alt: 'Sting',
        style: { height: 44 }
      })), _jsx('a', {}, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_6_assets_klarna_png___default.a,
        alt: 'Klarna',
        style: { height: 29 }
      })), _jsx('a', {
        href: 'https://verifiera.se/',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_8_assets_verifiera_png___default.a,
        alt: 'Verifiera',
        style: { height: 44 }
      }))))));
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Footer.defaultProps = {
  className: '',
  account: false
};
Footer.links = [{
  label: 'Bli ledare',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_9_views_Signup_constants__["a" /* LEADER_SIGNUP */]),
  exceptRole: 'leader'
}, {
  label: 'Registrera dig som förälder',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_9_views_Signup_constants__["c" /* PARENT_SIGNUP */]),
  auth: false
}, {
  label: 'Så funkar det',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])('static/sa-funkar-det')
}, {
  label: 'Om oss',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])('static/om-oss')
}, {
  label: 'Frågor & svar',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])('static/fragor-och-svar')
}, {
  label: 'Allmänna villkor',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])('static/allmanna-villkor')
}, {
  label: 'Kontakt',
  href: Object(__WEBPACK_IMPORTED_MODULE_10_utilities_routes__["c" /* reverse */])('static/kontakt')
}];


/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_facebook_share_link__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_facebook_share_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_facebook_share_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Svg_SvgFacebookLogo__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_4__Svg_SvgFacebookLogo__["a" /* default */], {});

var FacebookShare = function (_Component) {
  _inherits(FacebookShare, _Component);

  function FacebookShare() {
    _classCallCheck(this, FacebookShare);

    return _possibleConstructorReturn(this, (FacebookShare.__proto__ || Object.getPrototypeOf(FacebookShare)).apply(this, arguments));
  }

  _createClass(FacebookShare, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_facebook_share_link___default.a, {
        link: this.props.link
      }, void 0, function (link) {
        return _jsx('a', {
          href: link,
          target: '_blank',
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(_this2.props.className, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.button)
        }, void 0, _ref, 'Dela');
      });
    }
  }]);

  return FacebookShare;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

FacebookShare.defaultProps = {
  link: 'https://friendtivity.se',
  className: ''
};


/* harmony default export */ __webpack_exports__["a"] = (FacebookShare);

/***/ }),

/***/ 1212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  fill: 'currentColor',
  d: 'M448 80v352c0 26.5-21.5 48-48 48h-85.3V302.8h60.6l8.7-67.6h-69.3V192c0-19.6 5.4-32.9 33.5-32.9H384V98.7c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9H184v67.6h60.9V480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z'
});

var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({}, props, { viewBox: '0 0 448 512' }),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SvgFacebookLogo);

/***/ }),

/***/ 1213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  fill: '#2566b8',
  d: 'M94.683,9.692a.909.909,0,0,1-.535.988.949.949,0,0,1-1.165-.562c-.106-.4.2-1.223.626-1.336.321-.085.674.413.716.576.073.042.285.059.358.334ZM89.23,11.185c-.1-.377.18-1.4.551-1.5s.837.384,1.006,1.026a.767.767,0,0,1-.46.991A.816.816,0,0,1,89.23,11.185Z'
});

var _ref2 = _jsx('path', {
  fill: '#ff563b',
  d: 'M97.012,11.552c.116.435.354,4.257-3.236,5.186a5.073,5.073,0,0,1-5.957-2.853A.254.254,0,0,1,88,13.577l.026-.005c.172-.045,1.607,3.327,5.48,2.073a3.877,3.877,0,0,0,3-4.095c.039-.084.057-.248.183-.275C96.8,11.242,96.967,11.379,97.012,11.552Z'
});

var _ref3 = _jsx('path', {
  fill: '#2566b8',
  d: 'M99.575,10.052A7.1,7.1,0,0,0,95.977,6a7.009,7.009,0,0,0-2.609-.688h-.234c-.689,0-1.239,1.183-1.172,1.467.026.113.091.209.164.191s.653-1.219,1.487-1.142a5.245,5.245,0,0,1,2.041.769A6.69,6.69,0,0,1,97.47,8.226a6.255,6.255,0,0,1,1.216,2.015,7.3,7.3,0,0,1,.23,2.505,6.382,6.382,0,0,1-.644,2.268,6.817,6.817,0,0,1-3.54,3.234,6.354,6.354,0,0,1-4.6-.036,6.425,6.425,0,0,1-1.993-1.259A7.1,7.1,0,0,1,86.727,14.9a6.633,6.633,0,0,1-.385-4.76c.405-1.377,1.692-2.334,2.634-3.435a.154.154,0,0,0-.19-.237l-.289.17a2.728,2.728,0,0,0-.275.176,6.117,6.117,0,0,0-.532.4l-.255.217c-.084.073-.158.158-.239.236a6.923,6.923,0,0,0-2,4.948,7.21,7.21,0,0,0,.551,2.727,7.346,7.346,0,0,0,3.893,3.938,7.48,7.48,0,0,0,2.782.6,7.639,7.639,0,0,0,2.811-.486,7.426,7.426,0,0,0,4.087-3.819,7.322,7.322,0,0,0,.265-5.531Z'
});

var _ref4 = _jsx('path', {
  d: 'M13.86,8.407a1.338,1.338,0,0,0,1.35-1.468,1.249,1.249,0,0,0-1.194-1.3H14a1.3,1.3,0,0,0-1.3,1.3v.032C12.7,7.887,13.221,8.407,13.86,8.407Zm37.474,0a1.338,1.338,0,0,0,1.35-1.468,1.249,1.249,0,0,0-1.194-1.3h-.014a1.3,1.3,0,0,0-1.3,1.3v.032c0,.924.522,1.444,1.161,1.444Zm13.052,0a1.338,1.338,0,0,0,1.35-1.468,1.249,1.249,0,0,0-1.194-1.3h-.009a1.3,1.3,0,0,0-1.3,1.3c0,.01,0,.021,0,.032C63.225,7.887,63.747,8.407,64.386,8.407ZM83.4,17.2a.388.388,0,0,0-.4-.331c-.189,0-.308.26-.308.26a25.533,25.533,0,0,1-2.085,3.813V21.2c-.166-1.73-.5-3.814-.5-5.662a17.736,17.736,0,0,1,.569-4.1c0-.26-.118-.427-.379-.427a2.165,2.165,0,0,0-1.184.474c-.639.379-.806,3.814-.806,5.212s-1.421,3.363-2.085,3.363c-.688,0-1.539-.664-1.539-2.755s.875-4.169.875-5.164a1.287,1.287,0,0,0-1.319-1.435c-.165,0-.284.118-.284.355,0,1.256-1.089,4.074-1.089,6.206v.125c-.3.664-1.122,2.341-1.73,2.341-.782,0-1.54-1.066-1.54-3.339,0-1.849.047-3.364.119-4.573h1.35a1.046,1.046,0,0,0,.947-.806c0-.118-.4-.165-.947-.165-.332,0-.806-.023-1.28-.047.095-1.184.19-1.966.19-2.341a1.377,1.377,0,0,0-1.4-1.3c-.237,0-.4.095-.4.284A5.089,5.089,0,0,1,68.3,8.626c0,.4-.072,1.138-.138,2.109H68.11a.872.872,0,0,0-.923.818v.034c0,.1.379.166.9.19-.119,1.587-.237,3.53-.237,5.449V17.3c-.256.614-1.179,2.67-2.087,2.67-.947,0-.971-1.3-.971-2.724.237-2.724.569-4.429.569-5.425q0-.852-.782-.852a1.434,1.434,0,0,0-1.326,1.3c0,.782-.119,2.534-.119,4.642v.208A3.24,3.24,0,0,1,59.676,19.4a13.081,13.081,0,0,0,2.1-6.514c0-2.066-1.326-3.482-1.9-3.482-.26,0-.569.214-.569.355a8.454,8.454,0,0,1,.616,2.961,16.441,16.441,0,0,1-1.35,6.254h-.047c-.355,0-.734.551-.71.806a.335.335,0,0,0,.095.237.57.57,0,0,1-.332.138c-.592,0-1.113-1.185-1.113-4,0-1.611.165-2.8.165-3.363a1.624,1.624,0,0,0-1.586-1.848c-.332,0-.664.071-.664.332a4.365,4.365,0,0,1,.26,1.493,35.445,35.445,0,0,0,.226,4.321c-.008.022-.012.037-.012.037s-1.09,2.843-2.156,2.843c-.947,0-.971-1.3-.971-2.724.237-2.724.569-4.429.569-5.425q0-.852-.782-.852a1.434,1.434,0,0,0-1.326,1.3c0,.783-.119,2.534-.119,4.643v.208s-1.089,2.606-1.848,2.606c-.782,0-1.54-1.066-1.54-3.34,0-1.848.047-3.363.119-4.572h1.349a1.047,1.047,0,0,0,.948-.806c0-.119-.4-.165-.948-.165-.331,0-.8-.024-1.279-.047.095-1.185.19-1.967.19-2.342a1.377,1.377,0,0,0-1.4-1.3c-.237,0-.4.095-.4.283a5.145,5.145,0,0,1,.118,1.185c0,.4-.071,1.137-.137,2.108H45.2a.872.872,0,0,0-.923.818v.035c0,.1.379.165.9.19-.118,1.586-.236,3.53-.236,5.448v.066c-.252.568-1.134,2.445-1.778,2.445-.593,0-.948-.9-.948-5,.474-3.581,1.138-5.543,1.138-7.13s-.995-2.248-1.683-2.248c-.639,0-.689.521-.689,1.208,0,.758-.138,5.757-.138,5.827a2.347,2.347,0,0,0-2.227-1.635c-2.392,0-4.1,2.393-4.1,5.591a9.412,9.412,0,0,0,.055,1.034c-.3.654-1.12,2.352-1.713,2.352-.5,0-.783-.569-.783-1.377,0-2.066.735-4.738.735-5.543a2,2,0,0,0-2.022-1.966c-2.583,0-4.241,6.278-4.311,6.611a44.212,44.212,0,0,1,.5-6.136c0-.236-.118-.473-.688-.473a1.266,1.266,0,0,0-1.066.924,19.864,19.864,0,0,0-.451,4.928v.356a.52.52,0,0,0-.027.069s-1.208,2.866-2.914,2.866c-2.464,0-2.7-2.819-2.7-2.819a11.341,11.341,0,0,0,1.918.213c1.378,0,2.156-1.634,2.156-3.434,0-2.086-.711-2.893-1.967-2.893a3.8,3.8,0,0,0-.971-.213c-1.113,0-3.079,2.416-3.079,5.495a7.223,7.223,0,0,0,.075,1.059c-.305.715-1.181,2.566-2.042,2.566-.948,0-.971-1.3-.971-2.724.237-2.724.569-4.429.569-5.425q0-.852-.782-.853a1.435,1.435,0,0,0-1.327,1.3c0,.783-.118,2.534-.118,4.643v.208s-1.089,2.605-1.848,2.605c-.521,0-1.09-.615-1.09-1.563a37.414,37.414,0,0,1,.521-3.885c0-1.563-3.056-1.421-3.056-2.322a12.253,12.253,0,0,0,.332-2.937,1.4,1.4,0,0,0-1.3-1.256c-.782,0-1.089,1.3-1.089,2.44a5.146,5.146,0,0,0,1.112,2.558A5.653,5.653,0,0,1,2.158,15.38c.03-1.231.138-2.747.237-4.334C2.651,7.468,4.074-3.618,6.656,4.714c.413,1.336,1.653-2.342.11-4.03C6.491.387,5.956-.244,4.349.1.54.917.994,9.961.806,14.01H.668A.8.8,0,0,0,0,14.788,1.692,1.692,0,0,0,.729,15.93C.7,16.309.7,16.687.7,17.019c-.022,4.051,1.084,5.312,1.985,5.318a.965.965,0,0,0,1-.928V21.4a25.2,25.2,0,0,0-1.515-5.078c1.377-.156,3.8-1.09,4.642-3.157.138.075.254.127.254.127.688.237,1.184.332,1.184.852,0,.734-.45,1.8-.45,3.27,0,2.179,1.468,3.363,2.534,3.363a1.945,1.945,0,0,0,1.653-.689,8.287,8.287,0,0,0,.765-1.391c.256,1.3.9,2.251,2.317,2.251a2.225,2.225,0,0,0,1.7-.853,8.589,8.589,0,0,0,.812-1.508,3.9,3.9,0,0,0,3.9,2.456,3.706,3.706,0,0,0,2.771-1.161,7.556,7.556,0,0,0,.65-1.2c.238,1.632.775,2.459,1.34,2.459.26,0,.689-.119.689-.309,0-.26-.072-.4-.072-1.113,0-2.652,2.559-8.007,3.648-8.007.26,0,.379.19.379.569,0,1.089-.758,2.842-.758,5.164,0,2.156,1.138,3.34,2.3,3.34a1.945,1.945,0,0,0,1.634-.688,7.939,7.939,0,0,0,.784-1.4,3.1,3.1,0,0,0,3.03,2.321c1.563,0,2.914-2.582,2.984-3.695,0,1.99.924,3.648,2.037,3.648a1.85,1.85,0,0,0,1.493-.876,8.191,8.191,0,0,0,.748-1.362,2.888,2.888,0,0,0,2.592,2.333,2.4,2.4,0,0,0,1.73-.971,8.307,8.307,0,0,0,.764-1.4c.256,1.3.9,2.251,2.316,2.251a2.222,2.222,0,0,0,1.7-.853,8.915,8.915,0,0,0,.857-1.611c.427,2.008,1.094,2.724,1.726,2.724a2.7,2.7,0,0,0,1.042-.237,1.68,1.68,0,0,0,1.066-.639,6.094,6.094,0,0,0,.689.024,3.914,3.914,0,0,0,3.629-1.791c.238,1.364.876,2.379,2.341,2.379a2.225,2.225,0,0,0,1.7-.853,8.191,8.191,0,0,0,.748-1.362,2.887,2.887,0,0,0,2.592,2.333,2.4,2.4,0,0,0,1.73-.971,7.779,7.779,0,0,0,.668-1.188,2.44,2.44,0,0,0,1.132,1.639,4.984,4.984,0,0,0,1.871.592c1.326,0,2.559-2.511,2.559-2.511a19.471,19.471,0,0,1,.332,3.885,6.21,6.21,0,0,0-.876,3.293c0,.826.45,1.28.924,1.28.689,0,1.73-.827,1.73-4.383a6.406,6.406,0,0,0-.023-.664,13.527,13.527,0,0,0,2.623-4.455A1.632,1.632,0,0,0,83.4,17.2ZM21.417,11.889c.355,0,.664.551.664,1.326,0,2.179-1.326,3.222-2.961,3.222C19.12,13.856,20.375,11.889,21.417,11.889Zm16.652,7.959c-.853,0-1.563-1.138-1.563-3.411,0-2.725.924-4.691,2.322-4.691.971,0,1.563,1.279,1.563,3.435S39.016,19.848,38.069,19.848Z'
});

var SvgSiteLogo = function SvgSiteLogo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({ viewBox: '0 0 100 27.076' }, props),
    _ref,
    _ref2,
    _ref3,
    _ref4
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SvgSiteLogo);

/***/ }),

/***/ 1214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  d: 'M66.756,7.871a3.69,3.69,0,0,1,5.037,1.366h0L92.092,44.3a3.692,3.692,0,0,1-1.347,5.038L33.226,82.644a3.69,3.69,0,0,1-5.03-1.393L28.17,81.2,7.871,46.143A3.691,3.691,0,0,1,9.215,41.1l.022-.013L66.774,7.871M63.065,1.487,5.546,34.7A11.073,11.073,0,0,0,1.48,49.823l.007.011L21.785,84.9a11.072,11.072,0,0,0,15.121,4.066l.011-.006L94.454,55.739A11.073,11.073,0,0,0,98.52,40.618l-.007-.011L78.2,5.546A11.072,11.072,0,0,0,63.076,1.48Z'
});

var _ref2 = _jsx('path', {
  d: 'M56.938,61.5,34.573,74.414,17.965,45.645,40.331,32.728ZM35.92,69.357,51.9,60.131,38.983,37.766,23,46.992Z'
});

var _ref3 = _jsx('rect', {
  x: '53.309',
  y: '35.104',
  width: '25.834',
  height: '3.691',
  transform: 'translate(-9.602 38.063) rotate(-30)'
});

var _ref4 = _jsx('rect', {
  x: '56.994',
  y: '41.517',
  width: '25.834',
  height: '3.691',
  transform: 'translate(-12.315 40.765) rotate(-30)'
});

var _ref5 = _jsx('rect', {
  x: '60.688',
  y: '47.895',
  width: '25.834',
  height: '3.691',
  transform: 'translate(-15.009 43.467) rotate(-30)'
});

var SvgLicenseDriver = function SvgLicenseDriver(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({ viewBox: '0 0 100 90.441' }, props),
    _ref,
    _ref2,
    _ref3,
    _ref4,
    _ref5
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SvgLicenseDriver);

/***/ }),

/***/ 1215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  d: 'M74.2,8.34a17.594,17.594,0,0,1,11.966,4.491,16.257,16.257,0,0,1,5.508,12.017,16.254,16.254,0,0,1-5.508,12.016L50,70.05,13.831,36.864A16.254,16.254,0,0,1,8.323,24.848a16.257,16.257,0,0,1,5.508-12.017A17.594,17.594,0,0,1,25.8,8.34a17.594,17.594,0,0,1,11.966,4.491l6.593,6.051,5.627,5.084,5.627-5.084L62.2,12.831A17.594,17.594,0,0,1,74.169,8.34m0-8.339A26,26,0,0,0,56.593,6.7L50,12.746,43.407,6.7A26,26,0,0,0,25.8,0,26,26,0,0,0,8.2,6.7a24.208,24.208,0,0,0,0,36.321L50,81.355,91.8,43.017A24.2,24.2,0,0,0,91.8,6.7,26,26,0,0,0,74.2,0Z'
});

var SvgLicenseCpr = function SvgLicenseCpr(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({ viewBox: '0 0 100 81.355' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SvgLicenseCpr);

/***/ }),

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  d: 'M50,0A49.664,49.664,0,0,0,0,50a49.664,49.664,0,0,0,50,50,49.664,49.664,0,0,0,50-50A50.176,50.176,0,0,0,50,0ZM72.926,56.567H56.567V73.733H42.627V56.567H26.152V44.24H42.511V27.074H56.452V44.24H72.811V56.567Z'
});

var SvgPlus = function SvgPlus(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({ viewBox: '0 0 100 100' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SvgPlus);

/***/ }),

/***/ 1217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  d: 'M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z'
});

var SvgRefresh = function SvgRefresh(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({ viewBox: '0 0 1792 1792' }, props),
    _ref
  );
};

/* unused harmony default export */ var _unused_webpack_default_export = (SvgRefresh);

/***/ }),

/***/ 1218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(48);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _ref = _jsx('path', {
  d: 'M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z'
});

var SvgCross = function SvgCross(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["e" /* default */],
    _extends({ viewBox: '0 0 1792 1792' }, props),
    _ref
  );
};

/* unused harmony default export */ var _unused_webpack_default_export = (SvgCross);

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_1HiTD"};

/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/klarna.f48499e8.png";

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/sting.dcee38e6.png";

/***/ }),

/***/ 1222:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/verifiera.82b805e5.png";

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_2LF-h","nav":"_18kyb","navContainer":"Un2HS","extra":"_178DQ","logos":"_2GR9I","facebookButton":"_3yaPy"};

/***/ }),

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export componentSelector */
/* unused harmony export idSelector */
/* unused harmony export pageTypeSelector */
/* unused harmony export footerlessSelector */
/* unused harmony export isLoadingSelector */
/* unused harmony export errorSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_routes__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_selectors__ = __webpack_require__(147);





var componentSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_state_routes__["d" /* locationSelector */], function (location) {
  return location.routesMap[location.type].component;
});

var idSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_state_routes__["d" /* locationSelector */], function (location) {
  return location.routesMap[location.type].id;
});

var pageTypeSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_state_routes__["d" /* locationSelector */], function (location) {
  return location.routesMap[location.type].pageType;
});

var footerlessSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_state_routes__["d" /* locationSelector */], function (location) {
  return location.routesMap[location.type].footerless;
});

var isLoadingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_state_routes__["d" /* locationSelector */], function (state) {
  return state;
}, function (location, state) {
  return location.routesMap[location.type].isLoading && location.routesMap[location.type].isLoading(state);
});

var errorSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_state_routes__["d" /* locationSelector */], function (state) {
  return state;
}, function (location, state) {
  return location.routesMap[location.type].getError && location.routesMap[location.type].getError(state);
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createStructuredSelector"])({
  id: idSelector,
  component: componentSelector,
  isLoading: isLoadingSelector,
  error: errorSelector,
  pageType: pageTypeSelector,
  footerless: footerlessSelector,
  account: __WEBPACK_IMPORTED_MODULE_2__App_selectors__["a" /* accountSelector */]
}));

/***/ }),

/***/ 1225:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_2D8T3","appear":"C8ZS2","appear-active":"_2egK_","enter":"_3PQiL","enter-active":"_1PaXj","leave":"_3w1Kv","leave-active":"_1tPPr","footerWrapper":"_2HG3Q"};

/***/ }),

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faBars__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_layouts_Container__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_LinkNav__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_FindActivity_constants__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_Home_constants__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_Login_constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_Profile_constants__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_state_routes__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_user_icon_png__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_user_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_assets_user_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_css__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_6_components_Svg__["d" /* SvgSiteLogo */], {});

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      mobileMenuActive: 'auto'
    };
    return _this;
  }

  _createClass(Header, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.root, this.props.className, {
        fullwidth: this.props.fullWidth
      });
    }
  }, {
    key: 'toggleMobileMenu',
    value: function toggleMobileMenu(id) {
      this.setState(function (prev) {
        return {
          mobileMenuActive: prev.mobileMenuActive === id ? null : id
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          linksLeft = _props.linksLeft,
          linksRight = _props.linksRight,
          account = _props.account;

      // Let the mobile login/signup menu be open on page load if not logged in.

      var mobileMenuActive = this.state.mobileMenuActive === 'auto' ? account ? null : 'right' : this.state.mobileMenuActive;

      return _jsx('header', {
        className: this.getClassName()
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_layouts_Container__["a" /* default */], {
        size: this.props.fullWidth ? 'full' : 'large',
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.container
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome___default.a, {
        icon: __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid_faBars___default.a,
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.hamburger,
        onClick: function onClick() {
          return _this2.toggleMobileMenu('left');
        }
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.navs
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.logo,
        href: Object(__WEBPACK_IMPORTED_MODULE_9_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_11_views_Home_constants__["a" /* NAME */])
      }, void 0, _ref), _jsx(__WEBPACK_IMPORTED_MODULE_7_components_LinkNav__["a" /* default */], {
        links: linksLeft,
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.desktopNavs
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.navs, __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.desktopNavs)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_components_LinkNav__["a" /* default */], {
        links: linksRight
      }), this.props.children), _jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.avatar,
        src: __WEBPACK_IMPORTED_MODULE_15_assets_user_icon_png___default.a,
        alt: '',
        onClick: function onClick() {
          return _this2.toggleMobileMenu('right');
        }
      })), _jsx(__WEBPACK_IMPORTED_MODULE_5_layouts_Container__["a" /* default */], {
        size: this.props.fullWidth ? 'full' : 'large',
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.container, __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.mobileContainer, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.active, mobileMenuActive))
      }, void 0, mobileMenuActive === 'left' && _jsx('nav', {}, void 0, _jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.mobileNavs
      }, void 0, linksLeft.map(function (link) {
        return _jsx('li', {}, link.label, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], _extends({ className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.link }, link)));
      }))), mobileMenuActive === 'right' && _jsx('nav', {}, void 0, _jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.mobileNavs
      }, void 0, linksRight.map(function (link) {
        return _jsx('li', {}, link.label, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], _extends({ className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.link }, link)));
      }), account == null && _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.link,
        href: Object(__WEBPACK_IMPORTED_MODULE_9_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_12_views_Login_constants__["a" /* NAME */])
      }, void 0, 'Logga in'))), account && _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.link,
        href: Object(__WEBPACK_IMPORTED_MODULE_9_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_10_views_FindActivity_constants__["a" /* NAME */])
      }, void 0, 'Hitta aktivitet')), _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.link,
        href: Object(__WEBPACK_IMPORTED_MODULE_9_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_13_views_Profile_constants__["b" /* NAME */])
      }, void 0, 'Min sida')), _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.link,
        href: Object(__WEBPACK_IMPORTED_MODULE_9_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_14_state_routes__["a" /* ROUTE_LOGOUT */])
      }, void 0, 'Logga ut')))))));
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Header.defaultProps = {
  className: '',
  fullWidth: true,
  linksRight: [],
  account: false
};


/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ 1228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var LinkNav = function (_Component) {
  _inherits(LinkNav, _Component);

  function LinkNav() {
    _classCallCheck(this, LinkNav);

    return _possibleConstructorReturn(this, (LinkNav.__proto__ || Object.getPrototypeOf(LinkNav)).apply(this, arguments));
  }

  _createClass(LinkNav, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.root, this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('nav', {
        className: this.getClassName()
      }, void 0, _jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.list
      }, void 0, this.props.links.map(function (link) {
        return _jsx('li', {
          className: __WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.bullet
        }, link.label, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Link__["a" /* default */], _extends({}, link, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.link })));
      })));
    }
  }]);

  return LinkNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LinkNav.defaultProps = {
  className: ''
};


/* harmony default export */ __webpack_exports__["a"] = (LinkNav);

/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3xULi","list":"_2VTUK","link":"_3-r-g"};

/***/ }),

/***/ 1230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1R-qK","container":"_36r8C","mobileContainer":"_1eM24","active":"_1Fqq-","fullwidth":"_2ninB","logo":"_1lpmz","navs":"kodgW","desktopNavs":"_1DeG4","hamburger":"_3DnWb","avatar":"_2tYd0","mobileNavs":"_1ixMf","link":"_1bcGs"};

/***/ }),

/***/ 1231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_FindActivity_constants__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Login_constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Profile_constants__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_routes__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_user_icon_png__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_user_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_user_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var AccountNav = function (_Component) {
  _inherits(AccountNav, _Component);

  function AccountNav() {
    _classCallCheck(this, AccountNav);

    return _possibleConstructorReturn(this, (AccountNav.__proto__ || Object.getPrototypeOf(AccountNav)).apply(this, arguments));
  }

  _createClass(AccountNav, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.root, this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var account = this.props.account;

      var figureClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.figure, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.figureBlank, !account || !account.image));
      var accountContent = _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.name
      }, void 0, account ? account.name : 'Logga in'), _jsx('figure', {
        className: figureClassName
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.avatar,
        src: __WEBPACK_IMPORTED_MODULE_9_assets_user_icon_png___default.a,
        alt: ''
        // Override default image attributes if passed
      }, account ? account.image : {}))));

      return _jsx('nav', {
        className: this.getClassName()
      }, void 0, account ? _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.head
      }, void 0, accountContent) : _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_3_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_5_views_Login_constants__["a" /* NAME */]),
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.head
      }, void 0, accountContent), account && _jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.subnav
      }, void 0, _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_3_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_4_views_FindActivity_constants__["a" /* NAME */])
      }, void 0, 'Hitta aktivitet')), _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_3_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_6_views_Profile_constants__["b" /* NAME */])
      }, void 0, 'Min sida')), _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_3_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_7_state_routes__["a" /* ROUTE_LOGOUT */])
      }, void 0, 'Logga ut'))));
    }
  }]);

  return AccountNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AccountNav.defaultProps = {
  className: '',
  account: false
};


/* harmony default export */ __webpack_exports__["a"] = (AccountNav);

/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1qPL4","head":"_34-FQ","name":"_2iru5","figure":"_1apEf","avatar":"_2GAFO","figureBlank":"OjDHt","subnav":"_1tb9C"};

/***/ }),

/***/ 1233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loginFlow */
/* unused harmony export logoutFlow */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_first_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_FindActivity_constants__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Profile_constants__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Login_constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_actions__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(242);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loginFlow),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(logoutFlow),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(_callee);














function loginFlow() {
  var loginRoutes, request, location, next, nextRoute, account, _request$payload, username, password, userResponse, profileResponse, profile, _ref, employee, _ref2, parent;

  return regeneratorRuntime.wrap(function loginFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          loginRoutes = [__WEBPACK_IMPORTED_MODULE_6_views_Login_constants__["a" /* NAME */]];

        case 1:
          if (false) {
            _context.next = 72;
            break;
          }

          _context.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].login.toString());

        case 4:
          request = _context.sent;
          _context.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_utilities_routes__["b" /* locationSelector */]);

        case 7:
          location = _context.sent;
          next = location.query.next;
          nextRoute = next ? Object(__WEBPACK_IMPORTED_MODULE_2_redux_first_router__["pathToAction"])(next, location.routesMap) : null;

          // This variable will be filled up with data through a series of requests.

          account = null;

          // Get user.

          _context.prev = 11;

          if (!request.payload) {
            _context.next = 16;
            break;
          }

          _request$payload = request.payload, username = _request$payload.username, password = _request$payload.password;
          _context.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].client, 'authenticate'], username, password);

        case 16:
          _context.next = 18;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].user, 'getCurrent']);

        case 18:
          userResponse = _context.sent;

          account = _extends({}, account, {
            id: userResponse.data.id,
            name: userResponse.data.email,
            signupFlow: userResponse.data.signup_flow
          });
          _context.next = 29;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context['catch'](11);
          _context.next = 26;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].set({ account: account }));

        case 26:
          _context.next = 28;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].loginError(request.payload ? 'Invalid username or password' : 'Invalid authentication token.'));

        case 28:
          return _context.abrupt('continue', 1);

        case 29:
          _context.prev = 29;
          _context.next = 32;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].profile, 'getCurrent']);

        case 32:
          profileResponse = _context.sent;
          profile = profileResponse.data;
          _context.next = 36;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].loginSuccess());

        case 36:
          if (!profile) {
            _context.next = 41;
            break;
          }

          account = _extends({}, account, {
            id: profile.user_id,
            profileId: profile.id,
            name: profile.first_name
            // Redirect only if on login page
          });
          if (!(loginRoutes.indexOf(location.type) !== -1 || next)) {
            _context.next = 41;
            break;
          }

          _context.next = 41;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(nextRoute || Object(__WEBPACK_IMPORTED_MODULE_7_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_4_views_FindActivity_constants__["a" /* NAME */]));

        case 41:
          _context.next = 48;
          break;

        case 43:
          _context.prev = 43;
          _context.t1 = _context['catch'](29);

          if (!(loginRoutes.indexOf(location.type) !== -1)) {
            _context.next = 48;
            break;
          }

          _context.next = 48;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(nextRoute || Object(__WEBPACK_IMPORTED_MODULE_7_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_5_views_Profile_constants__["b" /* NAME */]));

        case 48:
          _context.prev = 48;
          _context.next = 51;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].employee, 'getCurrent']);

        case 51:
          _ref = _context.sent;
          employee = _ref.data;

          if (employee) {
            account = _extends({}, account, {
              employeeId: employee.id,
              image: {
                src: employee.picture && employee.picture.url
              }
            });
          }
          _context.next = 58;
          break;

        case 56:
          _context.prev = 56;
          _context.t2 = _context['catch'](48);

        case 58:
          _context.prev = 58;
          _context.next = 61;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].parent, 'getCurrent']);

        case 61:
          _ref2 = _context.sent;
          parent = _ref2.data;

          if (parent) {
            account = _extends({}, account, {
              parentId: parent.id
            });
          }
          _context.next = 68;
          break;

        case 66:
          _context.prev = 66;
          _context.t3 = _context['catch'](58);

        case 68:
          _context.next = 70;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].set({ account: account }));

        case 70:
          _context.next = 1;
          break;

        case 72:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[11, 22], [29, 43], [48, 56], [58, 66]]);
}

function logoutFlow() {
  return regeneratorRuntime.wrap(function logoutFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 11;
            break;
          }

          _context2.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].logout.toString());

        case 3:
          _context2.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].client, 'logout']);

        case 5:
          _context2.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8_state_actions__["b" /* resetState */])());

        case 7:
          _context2.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].set({ account: null, accountKey: Date.now() }));

        case 9:
          _context2.next = 0;
          break;

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(loginFlow);

        case 2:
          _context3.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* fork */])(logoutFlow);

        case 4:
          if (!__WEBPACK_IMPORTED_MODULE_3_api__["a" /* default */].client.isAuthenticated()) {
            _context3.next = 9;
            break;
          }

          _context3.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].login());

        case 7:
          _context3.next = 14;
          break;

        case 9:
          if (!(typeof window !== 'undefined')) {
            _context3.next = 14;
            break;
          }

          _context3.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["c" /* delay */])(0);

        case 12:
          _context3.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].set({ account: null }));

        case 14:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"ykPny"};

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ActivitiesAndSchools/index": 553,
	"./App/index": 221,
	"./Chat/index": 536,
	"./CreateActivity/index": 554,
	"./FindActivity/index": 555,
	"./Home/index": 556,
	"./Invitation/index": 557,
	"./Login/index": 558,
	"./Logout/index": 559,
	"./NotFound/index": 560,
	"./PasswordReset/index": 561,
	"./Profile/index": 562,
	"./ProfileLeader/index": 563,
	"./Receipt/index": 564,
	"./Signup/index": 565,
	"./SignupVerify/index": 566,
	"./Switch/index": 222,
	"./ViewActivity/index": 567
};
function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id])
		throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
	return __webpack_require__(id);
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1235;
module.exports = webpackContext;

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webfontloader__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_webfontloader__);


__WEBPACK_IMPORTED_MODULE_0_webfontloader___default.a.load({
  google: {
    families: ['Lato:400', 'Lato:700', 'Lato:900']
  },
  fontinactive: function fontinactive(familyName, fvd) {
    window.console.warn('WebFont.load() failed to load font:', {
      familyName: familyName,
      fvd: fvd
    });
  }
});

/***/ }),

/***/ 1239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_djedi_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_js__ = __webpack_require__(241);




if (__WEBPACK_IMPORTED_MODULE_2_config_js__["a" /* default */].SENTRY_DSN) {
    Raven.config(__WEBPACK_IMPORTED_MODULE_2_config_js__["a" /* default */].SENTRY_DSN).install();
}

__WEBPACK_IMPORTED_MODULE_0_djedi_react__["djedi"].options.baseUrl = __WEBPACK_IMPORTED_MODULE_1_api__["a" /* default */].client.apiUrl + '/cms/api';
__WEBPACK_IMPORTED_MODULE_0_djedi_react__["djedi"].options.languages.default = 'sv-se';

__WEBPACK_IMPORTED_MODULE_0_djedi_react__["djedi"].options.defaultRender = function (state) {
    switch (state.type) {
        case 'loading':
            return 'Laddar…';
        case 'error':
            return 'Inneh\xE5llet gick inte att h\xE4mta \uD83D\uDE1E (' + state.error.status + ')';
        case 'success':
            return state.content;
        default:
            return null;
    }
};

__WEBPACK_IMPORTED_MODULE_0_djedi_react__["djedi"].injectAdmin();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(191)))

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'app';

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makePersistentReducer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeReducer; });
/* unused harmony export addPersistentReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form_immutable__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utilities_debug__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_App_reducer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__persist__ = __webpack_require__(248);









var makePersistentReducer = function makePersistentReducer(key, reducer, duration) {
  var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(Object(__WEBPACK_IMPORTED_MODULE_5__persist__["a" /* load */])(key) || {});

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = reducer(state, action);
    Object(__WEBPACK_IMPORTED_MODULE_5__persist__["c" /* save */])(key, newState.toJS(), duration);
    return newState;
  };
};

var reducers = new __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]({
  app: __WEBPACK_IMPORTED_MODULE_3_views_App_reducer__["a" /* default */],
  form: __WEBPACK_IMPORTED_MODULE_0_redux_form_immutable__["reducer"]
});

var addReducer = function addReducer(key, reducer) {
  reducers = reducers.set(key, reducer);
  Object(__WEBPACK_IMPORTED_MODULE_2_utilities_debug__["a" /* default */])('Reducer injected: %o', key);
};

var removeReducer = function removeReducer(key) {
  reducers = reducers.delete(key);
  Object(__WEBPACK_IMPORTED_MODULE_2_utilities_debug__["a" /* default */])('Removed reducer: %o', key);
};

var addPersistentReducer = function addPersistentReducer(key) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  addReducer(key, makePersistentReducer.apply(undefined, [key].concat(rest)));
};

/* harmony default export */ __webpack_exports__["b"] = (function () {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();
  var action = arguments[1];
  return reducers.reduce(function (state, reducer, key) {
    return state.set(key, reducer(state.get(key), action));
  }, action.type === __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* RESET_STATE */] ? new __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]() : prevState);
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARENT_SIGNUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEADER_SIGNUP; });
var NAME = 'signup';
var PARENT_SIGNUP = 'signupParent';
var LEADER_SIGNUP = 'signupLeader';

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return djediNodesSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(196);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var stateSelector = function stateSelector(state) {
  return state.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */]) || __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* initialState */];
};
var accountSelector = function accountSelector(state) {
  return state.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */], 'account']);
};
var djediNodesSelector = function djediNodesSelector(state) {
  return state.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */], 'djediNodes']);
};

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(stateSelector, __WEBPACK_IMPORTED_MODULE_1_utilities_routes__["b" /* locationSelector */], function (appState, locationState) {
  return _extends({
    location: locationState
  }, appState.toObject());
}));

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(132);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({
  // States for `account`:
  // - false: Unknown if logged in or not yet.
  // - null/undefined: Not logged in.
  // - object: Logged in.
  account: false,
  // This key is updated when logging out and used to re-mount the entire
  // contents of the `<App>` component, causing all React state to be reset.
  // It’s important to only update when logging out, not in, to avoid
  // re-mounting on startup (the app is rendered with no user (`account ===
  // false` until the login requests are done)). The re-mount causes double
  // network requests, annoying flashes and can break redux-form.
  accountKey: Date.now(),
  djediNodes: {}
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */], {
  SET: function SET(state, _ref) {
    var payload = _ref.payload;
    return state.merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload));
  },
  ADD_DJEDI_NODES: function ADD_DJEDI_NODES(state, _ref2) {
    var payload = _ref2.payload;
    return state.set('djediNodes', payload);
  }
}), initialState));

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_reducers__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_sagas__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Switch__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_layouts_Header__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_AccountNav__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_Signup_constants__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sagas__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__selectors__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_css__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_regular__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_solid__["a" /* default */]);

var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
  defaultTitle: 'friendtivity',
  titleTemplate: '%s | friendtivity'
}, void 0, _jsx('meta', {
  charSet: 'utf-8'
}), _jsx('meta', {
  name: 'viewport',
  content: 'width=device-width, initial-scale=1, maximum-scale=5'
}));

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_10_views_Switch__["default"], {});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_toastify__["ToastContainer"], {
  position: 'bottom-center'
});

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_8_state_reducers__["a" /* addReducer */])(__WEBPACK_IMPORTED_MODULE_15__constants__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_16__reducer__["a" /* default */]);
      Object(__WEBPACK_IMPORTED_MODULE_9_state_sagas__["a" /* addSaga */])(__WEBPACK_IMPORTED_MODULE_15__constants__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_17__sagas__["a" /* default */]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      Object(__WEBPACK_IMPORTED_MODULE_8_state_reducers__["c" /* removeReducer */])(__WEBPACK_IMPORTED_MODULE_15__constants__["a" /* NAME */]);
      Object(__WEBPACK_IMPORTED_MODULE_9_state_sagas__["b" /* removeSaga */])(__WEBPACK_IMPORTED_MODULE_15__constants__["a" /* NAME */]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          account = _props.account,
          accountKey = _props.accountKey,
          location = _props.location;
      var fullWidth = location.routesMap[location.type].fullWidth;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_19__styles_css___default.a.root
      }, accountKey, _ref, _jsx(__WEBPACK_IMPORTED_MODULE_11_layouts_Header__["a" /* default */], {
        fullWidth: fullWidth,
        linksLeft: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["a" /* filterLinks */])(App.linksLeft, account),
        linksRight: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["a" /* filterLinks */])(App.linksRight, account),
        account: account
      }, void 0, account !== false && _jsx(__WEBPACK_IMPORTED_MODULE_12_components_AccountNav__["a" /* default */], {
        account: account && account.toJS()
      })), _ref2, _ref3);
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

App.defaultProps = {
  account: false
};
App.linksLeft = [{
  label: 'Bli ledare',
  href: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_14_views_Signup_constants__["a" /* LEADER_SIGNUP */]),
  exceptRole: 'leader'
}, {
  label: 'Så funkar det',
  href: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["c" /* reverse */])('static/sa-funkar-det')
}, {
  label: 'Pris, Q&A',
  href: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["c" /* reverse */])('static/fragor-och-svar')
}, {
  label: 'Om oss',
  href: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["c" /* reverse */])('static/om-oss')
}];
App.linksRight = [{
  label: 'Registrera dig som förälder',
  href: Object(__WEBPACK_IMPORTED_MODULE_13_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_14_views_Signup_constants__["c" /* PARENT_SIGNUP */]),
  auth: false
}];


/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(__WEBPACK_IMPORTED_MODULE_18__selectors__["b" /* default */])(App));

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ErrorBoundary__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Universal__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_layouts_Footer__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// import {
//     AnimatedTransitionGroup,
//     AnimatedChild,
// } from 'animated-transition-group'









var Switch = function Switch(_ref) {
  var id = _ref.id,
      component = _ref.component,
      pageType = _ref.pageType,
      footerless = _ref.footerless,
      account = _ref.account;
  return (
    // Transition disabled for now since it seems to trigger twice on page load,
    // which is very annoying.
    // <AnimatedTransitionGroup
    //     component="div"
    //     className={styles.root}
    //     appear={styles.appear}
    //     enter={styles.enter}
    //     leave={styles.leave}
    //     duration={500}
    //     debounce={500}
    // >
    //     <AnimatedChild key={id}>
    _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__styles_css___default.a.footerWrapper, !footerless))
    }, id, _jsx(__WEBPACK_IMPORTED_MODULE_4_components_ErrorBoundary__["a" /* default */], {
      from: 'switch'
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_components_Universal__["a" /* default */], {
      component: component,
      pageType: pageType
    })), !footerless && _jsx(__WEBPACK_IMPORTED_MODULE_6_layouts_Footer__["a" /* default */], {
      account: account
    }))
    //     </AnimatedChild>
    // </AnimatedTransitionGroup>

  );
};

Switch.defaultProps = {
  footerless: false,
  account: false
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(__WEBPACK_IMPORTED_MODULE_7__selectors__["a" /* default */])(Switch));

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a[this.props.size], this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        children
      );
    }
  }]);

  return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Container.defaultProps = {
  className: '',
  size: 'medium'
};


/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return runSaga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSaga; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeSaga; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utilities_debug__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middleware__ = __webpack_require__(351);







var tasks = new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]();

var runSaga = function runSaga(saga) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_3__middleware__["b" /* sagaMiddleware */].run.apply(__WEBPACK_IMPORTED_MODULE_3__middleware__["b" /* sagaMiddleware */], [saga].concat(args)).done.then(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2_utilities_debug__["a" /* default */])('Saga completed: %o', saga.name);
  });
};

var addSaga = function addSaga(key, saga) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var task = __WEBPACK_IMPORTED_MODULE_3__middleware__["b" /* sagaMiddleware */].run.apply(__WEBPACK_IMPORTED_MODULE_3__middleware__["b" /* sagaMiddleware */], [saga].concat(args));
  tasks = tasks.set(key, task);
  Object(__WEBPACK_IMPORTED_MODULE_2_utilities_debug__["a" /* default */])('Added saga: %o', key);
  return task;
};

var removeSaga = function removeSaga(key) {
  if (!tasks.get(key)) return;

  tasks.get(key).cancel();
  tasks = tasks.delete(key);
  Object(__WEBPACK_IMPORTED_MODULE_2_utilities_debug__["a" /* default */])('Removed saga: %o', key);
};

/* unused harmony default export */ var _unused_webpack_default_export = (function (store) {
  store.dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["a" /* END */]);
  return tasks.map(function (saga) {
    return saga.done;
  }).toArray();
});

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Endpoint = function Endpoint(client) {
  _classCallCheck(this, Endpoint);

  this.client = client;
};

/* harmony default export */ __webpack_exports__["a"] = (Endpoint);

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {var _ref = typeof window !== 'undefined' ? window : {},
    _ref$APP_CONFIG = _ref.APP_CONFIG,
    APP_CONFIG = _ref$APP_CONFIG === undefined ? {} : _ref$APP_CONFIG;

function getConf(overrideValue, envValue, defaultValue) {
  if (overrideValue != null) {
    return overrideValue;
  }

  if (envValue != null) {
    return envValue;
  }

  return defaultValue;
}

// All this file does really is exporting this object of configuration. It is a
// bit verbose because of Flow. That's a small price to pay for typo checking of
// the config keys, though!
//
// Note that we can't do `process.env[name]` because webpack needs to statically
// replace exact `process.env.FOO` pieces of code with values.
/* harmony default export */ __webpack_exports__["a"] = ({
  API_ENDPOINT: getConf(APP_CONFIG.API_ENDPOINT, process.env.API_ENDPOINT, 'http://localhost:8000'),
  API_OVERRIDE: getConf(APP_CONFIG.API_OVERRIDE, process.env.API_OVERRIDE, 'http://api:8000'),
  OAUTH2_CLIENT_ID: getConf(APP_CONFIG.OAUTH2_CLIENT_ID, process.env.OAUTH2_CLIENT_ID, ''),
  SOCKER_URI: getConf(APP_CONFIG.SOCKER_URI, process.env.SOCKER_URI, 'ws://localhost:8765'),
  GM_API_KEY: getConf(APP_CONFIG.GM_API_KEY, process.env.GM_API_KEY, ''),
  SENTRY_DSN: getConf(APP_CONFIG.SENTRY_DSN, process.env.SENTRY_DSN, ''),
  ENV: getConf(APP_CONFIG.ENV, process.env.ENV, 'live')
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(132);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var actions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createActions */])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* NAME */], {
  SET: undefined,
  ADD_DJEDI_NODES: undefined,

  // Authentication flow
  LOGIN: undefined,
  LOGIN_SUCCESS: undefined,
  LOGIN_ERROR: undefined,
  LOGOUT: undefined
}));

/* harmony default export */ __webpack_exports__["a"] = (actions[__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* NAME */]]);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'home';

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = save;
/* harmony export (immutable) */ __webpack_exports__["a"] = load;
/* harmony export (immutable) */ __webpack_exports__["b"] = remove;
/* unused harmony export clearAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_plugins_expire__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_plugins_expire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_store_plugins_expire__);



__WEBPACK_IMPORTED_MODULE_0_store___default.a.addPlugin(__WEBPACK_IMPORTED_MODULE_1_store_plugins_expire___default.a);

function save(key, data) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000 * 60 * 60 * 24 * 1;

  __WEBPACK_IMPORTED_MODULE_0_store___default.a.set(key, data, new Date().getTime() + duration);
}

function load(key) {
  return __WEBPACK_IMPORTED_MODULE_0_store___default.a.get(key);
}

function remove(key) {
  __WEBPACK_IMPORTED_MODULE_0_store___default.a.remove(key);
}

function clearAll() {
  __WEBPACK_IMPORTED_MODULE_0_store___default.a.clearAll();
}

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var propTypes = {
  from: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired
};

var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = {
      error: null
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      var from = this.props.from;

      this.setState({ error: error });
      Raven.captureException(error, { extra: { from: from, errorInfo: errorInfo } });
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var error = this.state.error;


      if (error) {
        return _jsx('p', {
          className: __WEBPACK_IMPORTED_MODULE_2__styles_css___default.a.errorPage
        }, void 0, 'Ett ov\xE4ntat fel uppstod.');
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(191)))

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_debug___default()('debug'));

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetState; });
var RESET_STATE = 'RESET_STATE';

var resetState = function resetState() {
  return {
    type: RESET_STATE
  };
};

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sagaMiddleware; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(155);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var sagaMiddleware = Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var middlewares = initial;

  middlewares.push(sagaMiddleware);

  if (process.browser && "production" === 'development') {
    middlewares.push(Object(__WEBPACK_IMPORTED_MODULE_1_redux_logger__["createLogger"])({
      collapsed: true,
      stateTransformer: function stateTransformer(state) {
        return state.toJS();
      }
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined, _toConsumableArray(middlewares));
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  HTTP_200_OK: 200,
  HTTP_201_CREATED: 201,
  HTTP_204_NO_CONTENT: 204,
  HTTP_400_BAD_REQUEST: 400,
  HTTP_401_UNAUTHORIZED: 401
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Token__ = __webpack_require__(1135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global FormData */







var Client = function () {
  function Client(apiUrl, clientId) {
    _classCallCheck(this, Client);

    this.apiUrl = apiUrl;
    this.clientId = clientId;
    this.token = new __WEBPACK_IMPORTED_MODULE_3__Token__["a" /* default */](this);
  }

  _createClass(Client, [{
    key: 'request',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_request) {
        var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var method, endpoint, expectedStatusCodes, data, params, response, statuses;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = _request.method, endpoint = _request.endpoint, expectedStatusCodes = _request.expectedStatusCodes, data = _request.data;
                params = {
                  method: method,
                  headers: _extends({}, this.token.headers()),
                  responseType: 'json'
                };


                if (data) {
                  if (typeof FormData !== 'undefined' && data instanceof FormData) {
                    params.data = data;
                  } else {
                    params.data = data ? JSON.stringify(data) : undefined;
                    params.headers = _extends({
                      Accept: 'application/json',
                      'Content-Type': 'application/json'
                    }, params.headers);
                  }
                }

                // FIXME: I have completely failed here as axios will throw an exceptio
                // as soon an error code is sent, which means that my error handling
                // down below won't ever be called. As we don't have tests for the
                // client now, I won't touch this, because it requires a lot of API
                // calling code to be altered. Fix it as soon there is enough time for
                // this.
                response = null;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default()('' + this.apiUrl + endpoint, params);

              case 7:
                response = _context.sent;
                _context.next = 27;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                if (!(this.token.credentials != null && _context.t0.response && _context.t0.response.status === __WEBPACK_IMPORTED_MODULE_2__status__["a" /* default */].HTTP_401_UNAUTHORIZED && retry === true)) {
                  _context.next = 21;
                  break;
                }

                console.info('The token has expired. Obtaining new...');
                _context.next = 16;
                return this.token.refreshToken();

              case 16:
                _context.next = 18;
                return this.request(_request, false);

              case 18:
                response = _context.sent;
                _context.next = 27;
                break;

              case 21:
                if (!(_context.t0.response && _context.t0.response.status >= 500 && _context.t0.response.status <= 599)) {
                  _context.next = 26;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].error('Ett oväntat fel uppstod.');
                throw _context.t0;

              case 26:
                throw _context.t0;

              case 27:
                if (!(expectedStatusCodes && !expectedStatusCodes.includes(response.status) || response.status > 400)) {
                  _context.next = 30;
                  break;
                }

                statuses = (expectedStatusCodes || []).join(' ,');
                throw new Error(['Received an unexpected response code (received: ', response.status + ', expected ' + statuses + ').'].join('\n'));

              case 30:
                if (!(response.status === __WEBPACK_IMPORTED_MODULE_2__status__["a" /* default */].HTTP_400_BAD_REQUEST)) {
                  _context.next = 32;
                  break;
                }

                return _context.abrupt('return', { errors: response.data });

              case 32:
                return _context.abrupt('return', { errors: null, data: response.data });

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function request(_x) {
        return _ref.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: 'authenticate',
    value: function authenticate(username, password) {
      return this.token.get(username, password);
    }
  }, {
    key: 'login',
    value: function login(authResponse) {
      return this.token.getFromAuthResponse(authResponse);
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.token.revoke();
    }
  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      return this.token.credentials != null;
    }
  }, {
    key: 'getRefreshToken',
    value: function getRefreshToken() {
      var credentials = this.token.credentials;

      return credentials ? credentials.refreshToken : null;
    }
  }, {
    key: 'refreshToken',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.token.credentials != null)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.token.refreshToken();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshToken() {
        return _ref2.apply(this, arguments);
      }

      return refreshToken;
    }()
  }]);

  return Client;
}();

/* harmony default export */ __webpack_exports__["a"] = (Client);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgSiteLogo__ = __webpack_require__(1213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__SvgSiteLogo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SvgLicenseDriver__ = __webpack_require__(1214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__SvgLicenseDriver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SvgLicenseCpr__ = __webpack_require__(1215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__SvgLicenseCpr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SvgPlus__ = __webpack_require__(1216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__SvgPlus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SvgRefresh__ = __webpack_require__(1217);
/* unused harmony reexport SvgRefresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SvgCross__ = __webpack_require__(1218);
/* unused harmony reexport SvgCross */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Svg = function Svg(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 100 100' }, restProps),
    children
  );
};

/* harmony default export */ __webpack_exports__["e"] = (Svg);













/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_universal_component__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_universal_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_universal_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Spinner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_layouts_Page__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);




var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_6_components_Spinner__["a" /* default */], {
  width: 45,
  height: 45,
  center: true
});

var LoadingScreen = function LoadingScreen() {
  return _ref;
};

var ErrorScreen = function ErrorScreen(_ref2) {
  var error = _ref2.error;
  return _jsx(__WEBPACK_IMPORTED_MODULE_7_layouts_Page__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_css___default.a.errorPage
  }, void 0, error ? error.message : 'Ett oväntat fel uppstod.');
};

ErrorScreen.defaultProps = {
  error: null
};

var Universal = __WEBPACK_IMPORTED_MODULE_5_react_universal_component___default()(function (_ref3) {
  var component = _ref3.component,
      pageType = _ref3.pageType;

  if (pageType === 'static') {
    return __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport___default()({
      id: 'static/${component}',
      file: '/app/source/components/Universal/index.js',
      load: function load() {
        return Promise.all([__webpack_require__(1165)("./" + component), __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss___default()('static/' + component, {})]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return __WEBPACK_IMPORTED_MODULE_0_path___default.a.join(__dirname, 'static/' + component);
      },
      resolve: function resolve() {
        return /*require.resolve*/(__webpack_require__(1167).resolve("./" + component));
      },
      chunkName: function chunkName() {
        return 'static/' + component;
      }
    });
  } else if (pageType === 'view') {
    return __WEBPACK_IMPORTED_MODULE_2_babel_plugin_universal_import_universalImport___default()({
      id: 'views/${component}/index',
      file: '/app/source/components/Universal/index.js',
      load: function load() {
        return Promise.all([__webpack_require__(1168)("./" + component + '/index'), __WEBPACK_IMPORTED_MODULE_1_babel_plugin_universal_import_importCss___default()('views/' + component + '-index', {})]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return __WEBPACK_IMPORTED_MODULE_0_path___default.a.join(__dirname, 'views/' + component + '/index');
      },
      resolve: function resolve() {
        return /*require.resolve*/(__webpack_require__(1235).resolve("./" + component + '/index'));
      },
      chunkName: function chunkName() {
        return 'views/' + component + '-index';
      }
    });
  }
  return null;
}, {
  minDelay: 500,
  loading: LoadingScreen,
  error: ErrorScreen
});

Universal.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  pageType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['view', 'static'])
};

/* harmony default export */ __webpack_exports__["a"] = (Universal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/user-icon.8eeeb4d2.png";

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      color = _ref.color,
      center = _ref.center,
      restProps = _objectWithoutProperties(_ref, ['className', 'color', 'center']);

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.wrapper, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.center, center))
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.svg, className),
      width: '40',
      height: '40',
      viewBox: '0 0 66 66'
    }, restProps),
    _jsx('circle', {
      cx: '33',
      cy: '33',
      r: '30',
      stroke: color
    })
  ));
};

Spinner.defaultProps = {
  className: '',
  center: false,
  color: '#000'
};

/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_site_logo_png__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_site_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_site_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var Page = function Page(_ref) {
  var url = _ref.url,
      canonicalUrl = _ref.canonicalUrl,
      title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      type = _ref.type,
      card = _ref.card,
      handle = _ref.handle,
      site = _ref.site,
      stock = _ref.stock,
      currency = _ref.currency,
      amount = _ref.amount,
      children = _ref.children,
      className = _ref.className,
      bodyAttributes = _ref.bodyAttributes,
      plain = _ref.plain,
      rest = _objectWithoutProperties(_ref, ['url', 'canonicalUrl', 'title', 'description', 'image', 'type', 'card', 'handle', 'site', 'stock', 'currency', 'amount', 'children', 'className', 'bodyAttributes', 'plain']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({
      plain: String(plain || false)
    }, rest, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.root, className)
    }),
    _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
      title: title,
      bodyAttributes: _extends({ plain: plain }, bodyAttributes)
    }, void 0, (url || canonicalUrl || process.browser) && _jsx('link', {
      rel: 'canonical',
      href: url || canonicalUrl || window.location
    }), description && _jsx('meta', {
      name: 'description',
      content: description
    }), image && _jsx('meta', {
      name: 'image',
      content: image
    }), url && _jsx('meta', {
      property: 'og:url',
      content: url
    }), title && _jsx('meta', {
      property: 'og:title',
      content: title
    }), description && _jsx('meta', {
      property: 'og:description',
      content: description
    }), image && _jsx('meta', {
      property: 'og:image',
      content: image
    }), site && _jsx('meta', {
      property: 'og:site_name',
      content: site
    }), type && _jsx('meta', {
      property: 'og:type',
      content: type
    }), card && _jsx('meta', {
      name: 'twitter:card',
      content: card
    }), title && _jsx('meta', {
      name: 'twitter:title',
      content: title
    }), description && _jsx('meta', {
      name: 'twitter:description',
      content: description
    }), handle && _jsx('meta', {
      name: 'twitter:site',
      content: handle
    }), handle && _jsx('meta', {
      name: 'twitter:creator',
      content: handle
    }), image && _jsx('meta', {
      name: 'twitter:image:src',
      content: image
    }), type === 'product' && stock && _jsx('meta', {
      name: 'product:availability',
      content: stock
    }), type === 'product' && currency && _jsx('meta', {
      name: 'product:price:currency',
      content: currency
    }), type === 'product' && amount && _jsx('meta', {
      name: 'product:price:amount',
      content: amount
    }), type === 'product' && site && _jsx('meta', {
      name: 'product:brand',
      content: site
    }), title && _jsx('meta', {
      itemProp: 'name',
      content: title
    }), description && _jsx('meta', {
      itemProp: 'description',
      content: description
    }), image && _jsx('meta', {
      itemProp: 'image',
      content: image
    })),
    children
  );
};

Page.defaultProps = {
  className: '',
  url: '',
  canonicalUrl: '',
  title: '',
  description: '',
  image: __WEBPACK_IMPORTED_MODULE_4__assets_site_logo_png___default.a,
  type: '',
  card: '',
  handle: '',
  site: 'friendtivity',
  stock: '',
  currency: '',
  amount: 0,
  bodyAttributes: {},
  plain: false
};

/* harmony default export */ __webpack_exports__["a"] = (Page);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAME; });
/* unused harmony export RECEIPT_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivityStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PaymentStatus; });
var NAME = 'viewActivity';
var RECEIPT_NAME = 'viewActivityReceipt';

var ActivityStatus = {
  PENDING: 0,
  STARTED: 1,
  FINISHED: 2,
  CANCELLED: 3
};

var PaymentStatus = {
  INITIALIZED: 0,
  AUTHORIZED: 1,
  CAPTURED: 2,
  CANCELLED: 3
};

/* unused harmony default export */ var _unused_webpack_default_export = (NAME);

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDIT_NAME; });
var NAME = 'createActivity';
var EDIT_NAME = 'editActivity';
/* unused harmony default export */ var _unused_webpack_default_export = (NAME);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PASSWORD_RESET_REQUEST; });
var NAME = 'passwordReset';
var PASSWORD_RESET_REQUEST = 'passwordResetRequest';

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'invitation';

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'activitiesAndSchools';

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'receipt';
/* unused harmony default export */ var _unused_webpack_default_export = (NAME);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
var NAME = 'signupVerify';

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = reverse;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterLinks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function reverse(routeId, params) {
  return _extends({ type: routeId }, params);
}

var locationSelector = function locationSelector(state) {
  var location = state.get('location');

  // `location.query` is supposed to always exist since we specify
  // `querySerializer: queryString` in states/routes.js but something’s buggy
  // so parse it here if needed as a workaround.
  return location.query != null ? location : _extends({}, location, {
    query: __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search)
  });
};

var filterLinks = function filterLinks(links, account) {
  var role = account && account.get('signupFlow');

  return links.filter(function (_ref) {
    var auth = _ref.auth,
        exceptRole = _ref.exceptRole;

    // Links can optionally define `auth` as a boolean to only show
    // for either non-logged in or logged in users.
    if (typeof auth === 'boolean') {
      // Hide items that depend on the logged in state until we know
      // whether we’re logged in or not.
      if (account === false) {
        return false;
      }

      var isAuthed = account != null;
      return auth === isAuthed;
    }
    // filter items in which exceptRole matches current users role
    if (typeof exceptRole === 'string') {
      return exceptRole !== role;
    }
    return true;
  }).map(function (_ref2) {
    var auth = _ref2.auth,
        exceptRole = _ref2.exceptRole,
        rest = _objectWithoutProperties(_ref2, ['auth', 'exceptRole']);

    return _extends({}, rest);
  });
};


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(569);
module.exports = __webpack_require__(771);


/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Raven) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_transit_immutable_js__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_transit_immutable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_transit_immutable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ErrorBoundary__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_store__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_App__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_styles_css__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_fonts__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared__ = __webpack_require__(1239);
var _this = this;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
















// Make Raven accessible from the console
window.Raven = Raven;

var initialState = window.__INITIAL_STATE__ ? __WEBPACK_IMPORTED_MODULE_5_transit_immutable_js___default.a.fromJSON(window.__INITIAL_STATE__) : undefined;

var rootEl = document.getElementById('root');
var Root = __WEBPACK_IMPORTED_MODULE_8_views_App__["default"];
var store = void 0;

var _ref = _jsx(Root, {});

var render = function render() {
    Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["hydrate"])(_jsx(__WEBPACK_IMPORTED_MODULE_6_components_ErrorBoundary__["a" /* default */], {
        from: 'main'
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_hot_loader__["AppContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"], {
        store: store
    }, Math.random(), _ref))), rootEl);
};

var init = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(Component) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_7_state_store__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory___default()(), initialState);

                    case 2:
                        store = _context2.sent;


                        if (false) {
                            module.hot.accept('views/App', function () {
                                Root = require('views/App').default;

                                render();
                            });

                            module.hot.accept('state/store', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _context.next = 2;
                                                return require('state/store').default(createHistory(), initialState);

                                            case 2:
                                                store = _context.sent;


                                                render();

                                            case 4:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this);
                            })));
                        }

                        render();

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function init(_x) {
        return _ref2.apply(this, arguments);
    };
}();

init();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(191)))

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"errorPage":"_3rDA3"};

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_djedi_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension_logOnlyInProduction__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension_logOnlyInProduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension_logOnlyInProduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_App_selectors__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middleware__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(116);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* global System */












/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(history) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();

    var _configureRoutes, routeReducer, routeMiddleware, routeEnhancer, thunk, store, nodes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _configureRoutes = Object(__WEBPACK_IMPORTED_MODULE_7__routes__["b" /* default */])(history), routeReducer = _configureRoutes.reducer, routeMiddleware = _configureRoutes.middleware, routeEnhancer = _configureRoutes.enhancer, thunk = _configureRoutes.thunk;


            Object(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* addReducer */])('location', routeReducer);

            store = Object(__WEBPACK_IMPORTED_MODULE_2_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_5__reducers__["b" /* default */], initialState, Object(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension_logOnlyInProduction__["composeWithDevTools"])(routeEnhancer, Object(__WEBPACK_IMPORTED_MODULE_6__middleware__["a" /* default */])([routeMiddleware])));


            if (false) {
              module.hot.accept('./reducers', function () {
                System.import('./reducers').then(function (reducerModule) {
                  store.replaceReducer(reducerModule.default);
                });
              });
            }

            nodes = Object(__WEBPACK_IMPORTED_MODULE_4_views_App_selectors__["c" /* djediNodesSelector */])(store.getState());

            __WEBPACK_IMPORTED_MODULE_0_djedi_react__["djedi"].addNodes(nodes);

            _context.next = 8;
            return thunk(store);

          case 8:
            return _context.abrupt('return', store);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})());

/***/ })

},[568]);


// WEBPACK FOOTER //
// main.64a0583af8c9b16c4783.js